/**
 * @name crud_contracts.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\crud_contracts.js
 */

//import { apiCall, getBaseDir } from './crud_contracts.js';

import TableBuilder from './table_builder.js';
import Swal from 'sweetalert2';

var getBaseDir = null, apiCall = null, enableForm = null, disableForm = null, getContractStatusName = null, getBusinessDoctorsListByBranchId = null, getBranchNameFromId = null, userHasRole = null, escapeSingleQuotes = null, getPaymentMethod = null, getPatientTypeDataByRole = null, moeda2float = null, float2moeda = null, userHasBranch = null;
var moment = require('moment-timezone');
const XLSX = require('xlsx');

$(function () {
    import('./utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        enableForm = utils.enableForm;
        disableForm = utils.disableForm;
        getContractStatusName = utils.getContractStatusName;
        getBusinessDoctorsListByBranchId = utils.getBusinessDoctorsListByBranchId;
        getBranchNameFromId = utils.getBranchNameFromId;
        userHasRole = utils.userHasRole;
        escapeSingleQuotes = utils.escapeSingleQuotes;
        getPaymentMethod = utils.getPaymentMethod;
        getPatientTypeDataByRole = utils.getPatientTypeDataByRole;
        moeda2float = utils.moeda2float;
        float2moeda = utils.float2moeda;
        userHasBranch = utils.userHasBranch;
        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname === utils.getBaseDir() + 'contratos/cadastros' || location.pathname === utils.getBaseDir() + 'pacientes/cadastros') {
            new Contracts(true, {
                getBaseDir: utils.getBaseDir,
                apiCall: utils.apiCall,
            });
        }
    });
});

class Contracts {
    constructor(onloadList = false, deps = {}) {
        this.deps = deps;
        this.operatorAllowedServices = [];
        this.selectedBranch = -1;
        this.businessPlans = [];
        this.currentFlowInterval = false;
        this.isAdminOrAssistant = userHasRole('ADMIN') || userHasRole('ADMIN_ASSISTANT');
        this.isAdmin = userHasRole('ADMIN');
        this.isPatientsPage = location.pathname === getBaseDir() + 'pacientes/cadastros';
        this.patientId = null;
        this.patientInfo = null;
        this.patientContracts = [];
        let self = this;

        // Resgata lista de serviços
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/employee/services',
            successCallback: function (res) {
                console.log('crud_contracts.js/employee/services', 'onLoad', res);

                if (res.error) {

                } else {
                    self.operatorAllowedServices = res.data;
                    let html = '<option selected default value="">-- Selecione uma opção --</option>';
                    for (let i in res.data) {
                        let serviceObj = res.data[i];
                        html += `
                            <option value="${serviceObj.ID}" data-service-time="${serviceObj.TEMPO_MINIMO}" data-info='${JSON.stringify(serviceObj)}'>${serviceObj.SERVICO}</option>
                        `;
                    }
                    $('#contract_update_service').html(html);
                    $('.js-contracts-services-list').html(html);
                    $('#edit_service_current_account_service').html(html);
                }
            },
            errorCallback(err) {
                console.error('ERROR', 'crud_contracts.js/employee/services', 'onLoad', err);
            }
        });

        // Resgata lista de origens de pacientes
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/origins',
            successCallback: function (res) {
                if (!res.error) {
                    let options = res.data;
                    let optionsHtml = '';
                    for (let i in options) {
                        let option = options[i];
                        optionsHtml += `<option value="${option.ID}">${option.ORIGEM}</option>`;
                    }
                    $("#edit_patient_origin").html(optionsHtml);
                }
            },
            errorCallback: function (err) {

            }
        });

        // Resgata lista de planos
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/plans',
            successCallback: function (res) {
                if (!res.error) {
                    self.businessPlans = res.data;

                    let html = '<option selected default value="">-- Selecione --</option>';
                    for (let i = 0; i < res.data.length; i++) {
                        let plan = res.data[i];
                        if (plan.VISIVEL == 0) continue;
                        html += `<option value='${plan.ID}' data-plan-info='${JSON.stringify(plan)}'>${plan.DESCRICAO}</option>`;
                    }
                    $('.js-contracts-plan-list').html(html);
                }
            },
            errorCallback: function (err) {
            }
        });

        // Resgata lista de tipos de serviço
        /*apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/service_type',
            successCallback: function(res) {
                if (!res.error) {
                    let html = '<option selected default value="">-- Selecione --</option>';
                    for(let i = 0; i < res.data.length; i++) {
                        let service = res.data[i];
                        html += `<option value="${service.ID}">${service.SERVICO}</option>`;
                    }
                    $('.js-contracts-service-type-list').html(html);
                }
            },
            errorCallback: function(err) {
            }
        });*/

        // Resgata lista de serviços
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/agenda_services',
            successCallback: function (res) {
                if (!res.error) {
                    let html = '<option selected default value="">-- Selecione --</option>';
                    for (let i = 0; i < res.data.length; i++) {
                        let service = res.data[i];
                        if (service.ID == 1 || service.ID == 3)
                            continue;
                        html += `<option value="${service.ID}" data-servico-info='${JSON.stringify(service)}'>${service.SERVICO}</option>`
                    }
                    let allowedComboServices = ['Massagem 15m', ' Escalda pés'];
                    let htmlComboServices = '<option selected default value="">-- Selecione --</option>';
                    for (let i = 0; i < res.data.length; i++) {
                        let service = res.data[i];
                        if (allowedComboServices.includes(service.SERVICO)) {
                            htmlComboServices += `<option value="${service.ID}" data-servico-info='${JSON.stringify(service)}'>${service.SERVICO}</option>`
                        }
                    }
                    $('.js-contracts-service-list').html(html);
                    $('.js-contracts-service-list-2').html(htmlComboServices);
                }
            },
            errorCallback: function (err) {
            }
        });

        // Resgata tipos de pacientes
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/business/patient_type',
            successCallback: function (res) {
                console.log('crud_contracts.js/business/patient_type', 'onLoad', res);

                if (res.error) {

                } else {
                    let html = '<option selected default value="">-- Selecione --</option>';
                    for (let i in res.data) {
                        let serviceObj = res.data[i];
                        html += `
                            <option value="${serviceObj.ID}">${serviceObj.SIGLA}</option>
                        `;
                    }
                    $('#contract_update_patient_type').html(html);
                }
            },
            errorCallback(err) {
                console.error('ERROR', 'crud_contracts.js/business/patient_type', 'onLoad', err);
            }
        });

        /*$('#edit_patient_postal_code').mask('00000-000', {
            onComplete: function (txt) { self.onFillPostalCode(txt); }
        });*/

        if (this.isPatientsPage) {
            $('.js-patient-view-contracts-dialog-body').html(`
                <div class="row"> 
                    <div class="col-sm-12">
                        <div class="mb-3 card">
                            <div class="tab-content p-2 js-contracts-registrations-conntainer">
                                <div class="d-flex justify-content-start mb-3">
                                    <button class="btn btn-primary js-contracts-create-new" data-bs-toggle="modal" data-bs-target="#modal-contract-create"><i class="fa fa-plus"></i> Criar Novo Contrato</button>
                                    <button class="btn btn-primary js-contracts-refresh ml-2"><i class="fas fa-sync"></i> Atualizar Lista</button>
                                </div>
                                <table id="table-contracts-list" class="align-middle mb-0 table table-borderless table-striped table-hover responsive-table table-responsive" style="overflow-x:visible !important;">
                                    <thead>
                                        <tr>
                                            <th class="text-center"></th>
                                            <th class="text-center">ID</th>
                                            <th class="text-center">Plano</th>
                                            <th class="text-center">Serviço</th>
                                            <th class="text-center">Data Adesão</th>
                                            <th class="text-center">Data Encerramento</th>
                                            <th class="text-center">Total Contrato</th>
                                            <th class="text-center">Qt Arquivos.</th>
                                            <th class="text-center">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody class="js-contracts-registrations-table">
                                        <tr>
                                            <td class="text-center" colspan="9">Carregando....</td>
                                        </tr>
                                    </tbody>
                                </table> 
                            </div>
                        </div>
                    </div>
                </div>
            `);
        }

        this.tableHandler = new TableBuilder({
            table: '#table-contracts-list',
            tableBody: '.js-contracts-registrations-table',
            data: [],
            rowsPerPage: parseInt($('.js-contracts-per-page option:selected').val()) || 100,
            filter: false,
            maxPages: 0,
            customId: "CrudContractsHandler",
            tableRowRenderer: function (rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function () {
                self.fetchContractsList();
            },
            OnClickLastPage: function () {
                self.fetchContractsList();
            },
        });

        if (!this.isPatientsPage) {
            this.fetchContractsList();
        }
        this.bindDomEvents();
        this.bindDomTableAndFilterEvents();
        this.bindQueryParams();
    }

    bindDomEvents() {
        this.contractInfo = null;

        let self = this;
        let contractPrinterType = null;

        $(".js-contracts-registrations-filter-form").on('submit', (e) => {
            e.preventDefault();
        });

        // Detecta clique para mostrar modal do impressão de contrato
        $(document).on('click', '.js-contract-printer', function () {
            let contractInfo = $(this).data('contract-info'),
                contractType = $(this).data('print-type');

            contractInfo.type = contractType;
            contractPrinterType = contractType;
            self.contractInfo = contractInfo;

            $('.js-contract-send-to-customer').prop('disabled', true);
            $(".modal-contract-printer-dialog").block(window._loader.loading);
            $('.js-autentique-transfer-flow').addClass('d-none');

            apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/contract',
                data: contractInfo,
                successCallback: function (res) {
                    if (!res.error) {
                        //$(".modal-contract-printer-dialog").unblock();
                        $('.js-contract-iframe').contents().find('html').html(res.data);

                        $('.js-contract-flow').html('');
                        self.getContractAutentiqueFlow(contractInfo.ID, contractType);
                        self.currentContractHtml = res.data;
                        self.currentContractID = contractInfo.ID;
                        self.contractData = contractInfo;
                        //console.log('self.contractData', self.contractData);
                        self.currentContractContactData = {
                            telefone: res.telefone,
                            email: res.email,
                            data_nasc: res.data_nasc,
                            idade: res.idade
                        }
                        self.curenctContractOriginContactData = null;
                        if (typeof res.transferencia_extras.email !== 'undefined' || null) {
                            self.curenctContractOriginContactData = res.transferencia_extras;
                            //$('.js-autentique-finance-responsible-switch').addClass('d-none');
                            //$('.js-autentique-finance-responsible-flow').find('input, select').prop('required', false);
                        } else {
                            //$('.js-autentique-finance-responsible-switch').removeClass('d-none');
                            //$('.js-autentique-finance-responsible-flow').find('input, select').prop('required', true);
                        }

                        if (contractType == 'quiropraxia' || contractType == 'massoterapia') {
                            if (res.idade < 18 /*&& self.contractInfo.FILIAL_ID == 14*/) {
                                $('.js-autentique-legal-responsible-flow').removeClass('d-none');
                                $('.js-autentique-legal-responsible-flow').find('input, select').prop('required', true);

                                //$('.js-autentique-finance-responsible-switch').removeClass('d-none');
                                $('.js-autentique-finance-responsible-flow').find('input, select').prop('required', false);
                            } else {
                                $('.js-autentique-legal-responsible-flow').addClass('d-none');
                                $('.js-autentique-legal-responsible-flow').find('input, select').prop('required', false);
                                $('.js-autentique-finance-responsible-flow').addClass('d-none');
                                $('.js-autentique-finance-responsible-flow').find('input, select').prop('required', false);
                                $('#contact_autentique_flow_finance_responsible').prop('checked', false);
                            }
                        }
                    } else {
                        $(".modal-contract-printer-dialog").block(window._loader.error);
                    }
                },
                errorCallback: function (err) {
                    $(".modal-contract-printer-dialog").block(window._loader.error);
                }
            });
        });

        $(document).on('click', '#contact_autentique_flow_finance_responsible', function () {
            /*if (self.currentContractContactData.idade < 18) {
                return window.toast({
                    error: true,
                    text: 'O contrato deve ser enviado para o responsável financeiro do paciente, que é menor de 18 anos.'
                });
            }*/
            if ($(this).is(':checked')) {
                $('.js-autentique-finance-responsible-flow').removeClass('d-none');
                // add required to all fiends inside .js-autentique-finance-responsible-flow
                $('.js-autentique-finance-responsible-flow').find('input, select').prop('required', true);
            } else {
                $('.js-autentique-finance-responsible-flow').addClass('d-none');
                $('.js-autentique-finance-responsible-flow').find('input, select').prop('required', false);
            }
        });

        $(document).on('click', '.js-contract-send-to-customer', function () {
            /*console.log('self.currentContractHtml', self.currentContractHtml);
            console.log('self.currentContractID', self.currentContractID);
            console.log('self.currentContractContactData', self.currentContractContactData);*/

            $("#contract_autentique_flow_contact_type").val('EMAIL');
            $("#contact_autentique_flow_contact_form").attr('type', 'email');
            $(".contact_autentique_flow_contact_type_str").text('email');
            $("#contact_autentique_flow_contact_form").val(self.currentContractContactData.email);

            if (self.curenctContractOriginContactData) {
                $("#contract_autentique_flow_contact_type_origin").val('EMAIL');
                $("#contact_autentique_flow_contact_form_origin").attr('type', 'email');
                $(".contact_autentique_flow_contact_type_str_origin").text('email');
                $("#contact_autentique_flow_contact_form_origin").val(self.curenctContractOriginContactData.email);
                $('.js-autentique-transfer-flow').removeClass('d-none');
            }

            $("#modal-contract-autentique-flow").modal('show');
        });

        $(document).on('change', '#contract_autentique_flow_contact_type', function () {
            let contactType = $(this).val();
            if (contactType == 'EMAIL') {
                $("#contact_autentique_flow_contact_form").attr('type', 'email');
                $("#contact_autentique_flow_contact_form").val(self.currentContractContactData.email);
            } else {
                $("#contact_autentique_flow_contact_form").attr('type', 'number');
                $("#contact_autentique_flow_contact_form").val(self.currentContractContactData.telefone);
            }
            $(".contact_autentique_flow_contact_type_str").text(contactType.toLowerCase());
        });

        $(document).on('change', '#contract_autentique_flow_contact_type_origin', function () {
            let contactType = $(this).val();
            if (contactType == 'EMAIL') {
                $("#contact_autentique_flow_contact_form_origin").attr('type', 'email');
                $("#contact_autentique_flow_contact_form_origin").val(self.curenctContractOriginContactData.email);
            } else {
                $("#contact_autentique_flow_contact_form_origin").attr('type', 'number');
                let getONlyNumberFromString = self.curenctContractOriginContactData.telefone.replace(/\D/g, '');
                $("#contact_autentique_flow_contact_form_origin").val(getONlyNumberFromString);
            }
            $(".contact_autentique_flow_contact_type_str_origin").text(contactType.toLowerCase());
        });

        $(document).on('change', '#contract_autentique_flow_contact_type_witness1', function () {
            let contactType = $(this).val();
            if (contactType == 'EMAIL') {
                $("#contact_autentique_flow_contact_form_witness1").attr('type', 'email');
                $("#contact_autentique_flow_contact_form_witness1").val('');
            } else {
                $("#contact_autentique_flow_contact_form_witness1").attr('type', 'number');
                $("#contact_autentique_flow_contact_form_witness1").val('');
            }
            $(".contact_autentique_flow_contact_type_str_witness1").text(contactType.toLowerCase());
        });

        $(document).on('change', '#contract_autentique_flow_contact_type_witness2', function () {
            let contactType = $(this).val();
            if (contactType == 'EMAIL') {
                $("#contact_autentique_flow_contact_form_witness2").attr('type', 'email');
                $("#contact_autentique_flow_contact_form_witness2").val('');
            } else {
                $("#contact_autentique_flow_contact_form_witness2").attr('type', 'number');
                $("#contact_autentique_flow_contact_form_witness2").val('');
            }
            $(".contact_autentique_flow_contact_type_str_witness2").text(contactType.toLowerCase());
        });

        $(document).on('change', '#contract_autentique_flow_contact_type_legal_responsible', function () {
            let contactType = $(this).val();
            if (contactType == 'EMAIL') {
                $("#contact_autentique_flow_legal_responsible_email").attr('type', 'email');
                $("#contact_autentique_flow_legal_responsible_email").val('');
            } else {
                $("#contact_autentique_flow_legal_responsible_email").attr('type', 'number');
                $("#contact_autentique_flow_legal_responsible_email").val('');
            }
            $(".contact_autentique_flow_contact_type_str_legal_responsible").text(contactType.toLowerCase());
        });

        $(document).on('change', '#contract_autentique_flow_contact_type_finance_responsible', function () {
            let contactType = $(this).val();
            if (contactType == 'EMAIL') {
                $("#contact_autentique_flow_finance_responsible_email").attr('type', 'email');
                $("#contact_autentique_flow_finance_responsible_email").val('');
            } else {
                $("#contact_autentique_flow_finance_responsible_email").attr('type', 'number');
                $("#contact_autentique_flow_finance_responsible_email").val('');
            }
            $(".contact_autentique_flow_contact_type_str_finance_responsible").text(contactType.toLowerCase());
        });

        $(document).on('submit', '.js-contract-autentique-flow', function (e) {
            e.preventDefault();
            Swal.fire({
                title: 'Enviar contrato para assinatura',
                text: 'Deseja realmente enviar o contrato para assinatura? O contrato será enviado via ' + $("#contract_autentique_flow_contact_type").val() + ' para ' + $("#contact_autentique_flow_contact_form").val() + '',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    //console.log('self.currentContractContactData', self.currentContractContactData);
                    $('.js-contract-send-to-customer').prop('disabled', true);
                    $(".modal-contract-printer-dialog").block(window._loader.loading);
                    $('.js-contract-autentique-flow').find('button[type="submit"]').prop('disabled', true);
                    window.toast({
                        error: false,
                        text: "Por favor, aguarde enquanto o contrato é enviado para assinatura..."
                    })

                    let apiData = {
                        html: self.currentContractHtml,
                        contractId: self.currentContractID,
                        contractType: contractPrinterType,
                        contact: $("#contact_autentique_flow_contact_form").val(),
                        contactType: $("#contract_autentique_flow_contact_type").val(),
                        originContact: $("#contact_autentique_flow_contact_form_origin").val(),
                        originContactType: $("#contract_autentique_flow_contact_type_origin").val(),
                        clinicResponsibleContact: $("#contact_autentique_flow_contact_form_clinic_manager_email").val(),
                        witness1Name: $("#contact_autentique_flow_witness1_name").val(),
                        witness1Contact: $("#contact_autentique_flow_contact_form_witness1").val(),
                        witness1ContactType: $("#contract_autentique_flow_contact_type_witness1").val(),
                        witness2Name: window._sessionData.contractWitnesses?.serviceContract?.name || 'Patrícia Carravetta',
                        witness2Contact: window._sessionData.contractWitnesses?.serviceContract?.email || 'patricia.carravetta@clinicasajustar.com.br',
                        witness2ContactType: 'EMAIL',
                        contractInfo: self.contractInfo,
                    };
                    if (self.contractInfo.TOTAL_PLANO < 1) {
                        apiData.witness2Name = window._sessionData.contractWitnesses?.courtesyContract?.name || 'João Lucas';
                        apiData.witness2Contact = window._sessionData.contractWitnesses?.courtesyContract?.email || 'joaolucas@clinicasajustar.com.br';
                    }
                    //if (self.contractInfo.FILIAL_ID == 14) {
                    apiData = {
                        ...apiData,
                        financeResponsible: $('#contact_autentique_flow_finance_responsible').is(':checked'),
                        ...$('#contact_autentique_flow_finance_responsible').is(':checked') ? {
                            financeResponsibleData: {
                                name: $('input[name="contact_autentique_flow_finance_responsible_name"]').val(),
                                document: $('input[name="contact_autentique_flow_finance_responsible_document"]').val(),
                                birthDate: $('input[name="contact_autentique_flow_finance_responsible_birthdate"]').val(),
                                address: $('input[name="contact_autentique_flow_finance_responsible_address"]').val(),
                                number: $('input[name="contact_autentique_flow_finance_responsible_number"]').val(),
                                postalCode: $('input[name="contact_autentique_flow_finance_responsible_cep"]').val(),
                                neighborhood: $('input[name="contact_autentique_flow_finance_responsible_neighborhood"]').val(),
                                city: $('input[name="contact_autentique_flow_finance_responsible_city"]').val(),
                                state: $('input[name="contact_autentique_flow_finance_responsible_state"]').val(),
                                phone: $('input[name="contact_autentique_flow_finance_responsible_phone"]').val(),
                                contact: $('input[name="contact_autentique_flow_finance_responsible_email"]').val(),
                                contactType: $("#contract_autentique_flow_contact_type_finance_responsible").val(),
                            }
                        } : {},
                        legalResponsible: self.currentContractContactData.idade < 18,
                        isOverSixteen: self.currentContractContactData.idade >= 16,
                        ...self.currentContractContactData.idade < 18 ? {
                            legalResponsibleData: {
                                name: $('input[name="contact_autentique_flow_legal_responsible_name"]').val(),
                                document: $('input[name="contact_autentique_flow_legal_responsible_document"]').val(),
                                birthDate: $('input[name="contact_autentique_flow_legal_responsible_birthdate"]').val(),
                                address: $('input[name="contact_autentique_flow_legal_responsible_address"]').val(),
                                number: $('input[name="contact_autentique_flow_legal_responsible_number"]').val(),
                                postalCode: $('input[name="contact_autentique_flow_legal_responsible_cep"]').val(),
                                neighborhood: $('input[name="contact_autentique_flow_legal_responsible_neighborhood"]').val(),
                                city: $('input[name="contact_autentique_flow_legal_responsible_city"]').val(),
                                state: $('input[name="contact_autentique_flow_legal_responsible_state"]').val(),
                                phone: $('input[name="contact_autentique_flow_legal_responsible_phone"]').val(),
                                contact: $('input[name="contact_autentique_flow_legal_responsible_email"]').val(),
                                contactType: $("#contract_autentique_flow_contact_type_legal_responsible").val(),
                            }
                        } : {}
                    }
                    //}

                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/patient/contract/autentique/create_document',
                        data: apiData,
                        successCallback: function (res) {
                            $('.js-contract-autentique-flow').find('button[type="submit"]').prop('disabled', false);
                            window.toast({
                                error: res.error,
                                text: res.message
                            })
                            $(".modal-contract-printer-dialog").unblock();
                            if (!res.error) {
                                self.getContractAutentiqueFlow(self.currentContractID, contractPrinterType, false);
                                $('.js-contract-send-to-customer').prop('disabled', true);
                            } else {
                                $('.js-contract-send-to-customer').prop('disabled', false);
                            }
                            $('.js-contract-autentique-flow-close').trigger('click');
                        },
                        errorCallback: function (err) {
                            $('.js-contract-autentique-flow').find('button[type="submit"]').prop('disabled', false);
                            $(".modal-contract-printer-dialog").unblock();
                            //$(".modal-contract-printer-dialog").block(window._loader.error);
                        }
                    });
                }
            });
        });

        // Detecta clique para mostrar modal de transferência de contrato
        $(document).on('click', '.js-contract-transfer', function () {
            let contractInfo = $(this).data('contract-info');
            self.selectedContractForTransfer = contractInfo;
            //console.log('self.selectedContractForTransfer', self.selectedContractForTransfer);

            $('.modal-marketing-transfer-lead-dialog').block(window._loader.loading);
            apiCall({
                method: 'GET',
                endpoint: 'api/v1/patient/contract/sessions',
                data: {
                    contractId: contractInfo.ID
                },
                successCallback: function (res) {
                    $('.modal-marketing-transfer-lead-dialog').unblock();
                    if (!res.error) {
                        let attendedSessions = 0,
                            scheduledSessions = 0,
                            openSessions = 0;
                        for (let i in res.data) {
                            let parcela = res.data[i];
                            if (parcela) {
                                if (parcela.STATUS == 'A') {
                                    attendedSessions++;
                                }
                                if (parcela.AGENDA_ID != null && parcela.STATUS == null) {
                                    scheduledSessions++;
                                }
                                if (parcela.STATUS == null) {
                                    openSessions++;
                                }
                            }
                        }

                        $('#contract_transfer_sessions_attedend').html(attendedSessions);
                        $('#contract_transfer_sessions_scheduled').html(scheduledSessions);
                        $('#contract_transfer_sessions_open').html(openSessions);
                    } else {
                        $(".modal-marketing-transfer-lead-dialog").block(window._loader.error);
                    }
                },
                errorCallback: function (err) {
                    $(".modal-marketing-transfer-lead-dialog").block(window._loader.error);
                }
            });

            let filialNome = getBranchNameFromId(contractInfo.FILIAL_ID);

            $('#contract_transfer_branch_id').val(filialNome);
            $('#contract_transfer_customer_document_id').val(contractInfo.CPF != null ? contractInfo.CPF : contractInfo.PASSAPORTE);
            $('#contract_transfer_customer_name').val(contractInfo.CLIENTE_NOME);
            $('#contract_transfer_contract_id').val(contractInfo.ID);
        });

        $('#contract_transfer_new_customer').select2({
            placeholder: "Busque por telefone, nome ou email",
            theme: 'bootstrap-5',
            minimumInputLength: 3,
            dropdownParent: $("#modal-contract-transfer"),
            ajax: {
                url: getBaseDir() + 'api/v1/patient/search',
                delay: 1000,
                data: function (params) {
                    var query = {
                        search: params.term,
                        branchId: self.selectedBranch || -1,
                        page: params.page || 1,
                        allContracts: true
                    }
                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;

                    var results = [];
                    $.each(data.results, function (k, v) {
                        results.push({
                            id: v.ID,
                            text: `${v.ID} - ${v.TEXT} - ${v.CADASTRO_COMPLETO == 'N' ? 'Sem CPF' : v.CPF}${v.CONTRATO_ID != null ? ` - C${v.CONTRATO_ID} (${v.SESSOES_REALIZADAS}/${v.TOTAL_SESSOES})` : ' - Sem Contrato'}`,
                            info: v
                        });
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            }
        });

        $('#contract_transfer_new_customer').on('select2:select', function (e) {
            $("#contract_transfer_new_customer_id").val(e.params.data.info.ID);
        });

        $('.js-contract-transfer-clear-selected-patient').click(function () {
            $("#contract_transfer_new_customer_id").val('');
            $('#contract_transfer_new_customer').val("").trigger("change");
        });

        // Detecta clique para mostrar modal de alteração de comissão
        $(document).on('click', '.js-contract-update-commision', function () {
            let contractInfo = $(this).data('contract-info');

            $('#contract_commision_contract_id').val(contractInfo.ID);
            $('#contract_commision_customer_name').val(contractInfo.CLIENTE_NOME);
        });

        // Detecta clique para mostrar modal de transferência de contrato
        $(document).on('click', '.js-contract-basic-update', function () {
            let contractInfo = $(this).data('contract-info');

            $('#contract_update_contract_id').val(contractInfo.ID);
            $('#contract_update_customer_name').val(contractInfo.CLIENTE_NOME);

            apiCall({
                method: 'GET',
                endpoint: 'api/v1/business/doctors',
                data: { branch_id: contractInfo.FILIAL_ID },
                successCallback: function (res) {
                    //console.log('crud_contracts.js/business/doctors', res);
                    if (!res.error) {
                        let html = '<option selected default value="">-- Selecione --</option>';
                        for (let i in res.data) {
                            let brancheData = res.data[i];
                            html += `<option value="${brancheData.DOUTOR_ID}">${brancheData.PRIMEIRO_NOME}</option>`;
                        }
                        $('select[name="contract_update_doctor_id"]').html(html);
                    } else {

                    }
                },
                errorCallback: function (err) {

                }
            });
        });

        $(document).on('click', '.js-contract-cancel-autentique-flow', function () {
            $('.js-contract-cancel-autentique-flow').prop('disabled', true);
            $(".modal-contract-printer-dialog").block(window._loader.loading);

            Swal.fire({
                title: 'Cancelar Fluxo Autentique #' + self.currentContractID,
                text: 'Ao cancelar o fluxo de assinatura, o contrato será removido do Autentique. O contrato NÃO será removido do sistema TheQuiro!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.js-contract-cancel-autentique-flow').prop('disabled', true);
                    $(".modal-contract-printer-dialog").block(window._loader.loading);
                    if (self.currentFlowInterval) {
                        self.autentiqueFlowApiCall.abort();
                        clearInterval(self.currentFlowInterval);
                        self.currentFlowInterval = false;
                    }
                    apiCall({
                        method: 'GET',
                        endpoint: 'api/v1/patient/contract/autentique/delete_document',
                        data: {
                            contractId: self.currentContractID
                        },
                        successCallback: function (res) {
                            $(".modal-contract-printer-dialog").unblock();
                            if (!res.error) {
                                $('.js-contract-flow').html('');
                                $('.js-contract-send-to-customer').prop('disabled', false);

                                if (contractPrinterType == 'cancelamento') {
                                    self.getContractAutentiqueFlow(self.currentContractID, contractPrinterType, true);
                                }
                            } else {
                                $('.js-contract-send-to-customer').prop('disabled', false);
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-printer-dialog").block(window._loader.error);
                        }
                    });
                } else {
                    $('.js-contract-cancel-autentique-flow').prop('disabled', false);
                    $(".modal-contract-printer-dialog").unblock();
                }
            });
        });

        $(document).on('click', '.js-contract-unblock-autentique-flow', function () {
            $('.js-contract-unblock-autentique-flow').prop('disabled', true);
            $(".modal-contract-printer-dialog").block(window._loader.loading);

            let contractId = $(this).data('contract-id');

            Swal.fire({
                title: 'Desbloquear Fluxo de Assinaturas #' + contractId,
                text: 'Ao desbloquear o fluxo de assinatura do contrato, o prazo de assinatura será estendido em 3 dias.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'GET',
                        endpoint: 'api/v1/patient/contract/autentique/unblock_flow',
                        data: {
                            contractId: contractId
                        },
                        successCallback: function (res) {
                            $(".modal-contract-printer-dialog").unblock();
                            if (!res.error) {
                                //$('.js-contract-flow').html('');
                                $('.js-contract-send-to-customer').prop('disabled', false);
                                $('.js-contract-unblock-autentique-flow').prop('disabled', true);
                                self.getContractAutentiqueFlow(contractId, contractPrinterType, true);

                                Swal.fire({
                                    title: 'Fluxo desbloqueado!',
                                    text: 'O fluxo de assinatura do contrato foi desbloqueado com sucesso.',
                                    icon: 'success',
                                    showCancelButton: false,
                                    confirmButtonText: 'OK',
                                    confirmButtonColor: '#3085d6',
                                    reverseButtons: true
                                });
                                //}
                            } else {
                                $('.js-contract-send-to-customer').prop('disabled', false);
                                $('.js-contract-unblock-autentique-flow').prop('disabled', false);
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-printer-dialog").block(window._loader.error);
                        }
                    });
                } else {
                    $('.js-contract-unblock-autentique-flow').prop('disabled', false);
                    $(".modal-contract-printer-dialog").unblock();
                }
            })
        })

        $(document).on('click', '.js-contract-remove-signer', function () {
            let signerId = $(this).data('public-id');
            $('.js-contract-remove-signer').prop('disabled', true);
            $(".modal-contract-printer-dialog").block(window._loader.loading);

            Swal.fire({
                title: 'Remover Signatário do Contrato #' + self.currentContractID,
                text: 'Deseja realmente remover o signatário do contrato? Fique tranquilo(a) que o contrato NÃO será removido do sistema TheQuiro!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.js-contract-remove-signer').prop('disabled', true);
                    $(".modal-contract-printer-dialog").block(window._loader.loading);
                    apiCall({
                        method: 'GET',
                        endpoint: 'api/v1/patient/contract/autentique/remove_signer',
                        data: {
                            contractId: self.currentContractID,
                            signerId
                        },
                        successCallback: function (res) {
                            $(".modal-contract-printer-dialog").unblock();
                            if (!res.error) {
                                self.getContractAutentiqueFlow(self.currentContractID, contractPrinterType);
                            } else {
                                $('.js-contract-remove-signer').prop('disabled', false);
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-printer-dialog").block(window._loader.error);
                        }
                    });
                } else {
                    $('.js-contract-remove-signer').prop('disabled', false);
                    $(".modal-contract-printer-dialog").unblock();
                }
            });
        });

        $(document).on('hidden.bs.modal', '#modal-contract-printer', function () {
            if (self.currentFlowInterval) {
                self.autentiqueFlowApiCall.abort();
                clearInterval(self.currentFlowInterval);
                self.currentFlowInterval = false;
            }
            self.contractInfo['generation_finance_responsible'] = false;
            self.contractInfo['generation_legal_responsible'] = false;

            self.contractInfo['generation_finance_responsible_data'] = null;
            self.contractInfo['generation_legal_responsible_data'] = null;

            // remove generation_finance_responsible from contractInfo
            delete self.contractInfo['generation_finance_responsible'];
            delete self.contractInfo['generation_legal_responsible'];
            delete self.contractInfo['generation_finance_responsible_data'];
            delete self.contractInfo['generation_legal_responsible_data'];

            $('#contact_autentique_flow_finance_responsible_name').val('');
            $('#contact_autentique_flow_finance_responsible_document').val('');
            $('#contact_autentique_flow_finance_responsible_birthdate').val('');
            $('#contact_autentique_flow_finance_responsible_address').val('');
            $('#contact_autentique_flow_finance_responsible_number').val('');
            $('#contact_autentique_flow_finance_responsible_cep').val('');
            $('#contact_autentique_flow_finance_responsible_neighborhood').val('');
            $('#contact_autentique_flow_finance_responsible_city').val('');
            $('#contact_autentique_flow_finance_responsible_state').val('');
            $('#contact_autentique_flow_finance_responsible_phone').val('');
            $('#contact_autentique_flow_finance_responsible_email').val('');

            $('#contact_autentique_flow_legal_responsible_name').val('');
            $('#contact_autentique_flow_legal_responsible_document').val('');
            $('#contact_autentique_flow_legal_responsible_birthdate').val('');
            $('#contact_autentique_flow_legal_responsible_address').val('');
            $('#contact_autentique_flow_legal_responsible_number').val('');
            $('#contact_autentique_flow_legal_responsible_cep').val('');
            $('#contact_autentique_flow_legal_responsible_neighborhood').val('');
            $('#contact_autentique_flow_legal_responsible_city').val('');
            $('#contact_autentique_flow_legal_responsible_state').val('');
            $('#contact_autentique_flow_legal_responsible_phone').val('');
            $('#contact_autentique_flow_legal_responsible_email').val('');
        });

        $(document).on('submit', '.js-contract-reactivation-request-form', function (e) {
            e.preventDefault();
            e.stopPropagation();
            Swal.fire({
                title: 'Reativar Contrato #' + self.contractData.ID,
                text: 'Deseja realmente reativar o contrato? Fique tranquilo(a) que o contrato NÃO será removido do sistema TheQuiro!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.js-contract-reactivation-request-form').find('button[type="submit"]').prop('disabled', true);
                    $(".modal-contract-printer-dialog").block(window._loader.loading);
                    let formData = new FormData();
                    formData.append('contract_reactivation_contract_id', self.contractData.ID);
                    formData.append('contract_reactivation_payment_proof', $('#contract_reactivation_payment_proof')[0].files[0]);
                    formData.append('contract_reactivation_obs', $('#contract_reactivation_obs').val());
                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/patient/contract/reactivate_form',
                        data: formData,
                        processData: false,
                        contentType: false,
                        successCallback: function (res) {
                            $('.js-contract-reactivation-request-form').find('button[type="submit"]').prop('disabled', false);
                            window.toast({
                                error: res.error,
                                text: res.message
                            })
                            $(".modal-contract-printer-dialog").unblock();
                            if (!res.error) {
                                location.href = getBaseDir() + 'chamados';
                                $('.js-contract-send-to-customer').prop('disabled', true);
                            } else {
                                $('.js-contract-send-to-customer').prop('disabled', false);
                            }
                        },
                        errorCallback: function (err) {
                            $('.js-contract-reactivation-request-form').find('button[type="submit"]').prop('disabled', false);
                            $(".modal-contract-printer-dialog").block(window._loader.error);
                        }
                    });
                }
            });
        });

        $(document).on('change', '.js-contracts-with-pending-signature-flow', function () {
            self.fetchContractsList();
        });

        $(document).on('change', '.js-contracts-with-massage-therapy', function () {
            self.fetchContractsList();
        });

        $(document).on('click', '.js-contracts-export-button', function () {
            self.exportContracts();
        });

        $(document).on('click', '.js-contract-flow-refresh', function () {
            let contractId = $(this).data('contract-id');
            let contractType = $(this).data('contract-type');
            $('.js-contract-flow-refresh').prop('disabled', true);
            self.getContractAutentiqueFlow(contractId, contractType, false);
        });

        $(document).on('change', 'input[name="financial_responsible_choice"]', function () {
            let hasFinancialResponsible = $(this).val() === 'yes';
            let financialForm = $('.js-autentique-finance-responsible-flow');
            let hiddenCheckbox = $('#contact_autentique_flow_finance_responsible');

            if (hasFinancialResponsible) {
                financialForm.removeClass('d-none');
                financialForm.find('input, select').prop('required', true);
                hiddenCheckbox.prop('checked', true);
            } else {
                financialForm.addClass('d-none');
                financialForm.find('input, select').prop('required', false);
                financialForm.find('input, select').val('');
                hiddenCheckbox.prop('checked', false);
            }
        });

        this.bindDOMContractInsert();
        this.bindDOMContractUpdate();
        this.bindDOMContractUploads();
        this.bindDOMContractTransfer();
        this.bindDOMContractCancellation();
        this.bindDOMContractReactivation();
        this.bindDOMContractFinancialChanges();
        this.bindDOMContractUpgrade();
        this.bindDOMPatientsPageContracts();
    }

    bindDOMPatientsPageContracts() {
        let self = this;

        $(document).on('click', '.js-patient-view-contracts', function () {
            self.patientInfo = $(this).data('patient-info');
            self.patientId = self.patientInfo.ID;
            self.selectedBranch = self.patientInfo.FILIAL_ID;
            $('.js-patient-view-contracts-dialog-title-id').html(self.patientInfo.NOME_COMPLETO);
            self.fetchContractsList(true);
            $('#modal-patient-contracts').modal('show');
        });

        $(document).on('click', '.js-contracts-refresh', function () {
            self.fetchContractsList(true);
        });
    }

    bindQueryParams() {
        let self = this;
        let urlParams = new URLSearchParams(window.location.search);
        let contractId = urlParams.get('contract_id');
        let branchId = urlParams.get('branch');

        if (contractId == null || branchId == null)
            return;

        let calledCallback = false;
        this.isLoadingQuerySearch = true;

        $(".js-contracts-registrations-table").block(window._loader.loading);

        function OnBusinessReady() {
            if (calledCallback)
                return;
            calledCallback = true;

            //get select options count
            setTimeout(function () {
                // Select branch by name
                if (branchId) {
                    //$(".js-patients-registrations-container").block(window._loader.loading);

                    var intv = setInterval(function () {
                        if (window._sessionData.businessBranches) {
                            //console.log('$(".js-business-branches-selector option:selected").text()', $(".js-business-branches-selector option:selected").text());

                            $(".js-business-branches-selector option").filter(function () {
                                return $(this).val() === branchId;
                            }).prop('selected', true);
                            $(".js-contracts-registrations-branches-selector").trigger('change');

                            if (self.selectedBranch == '' || self.selectedBranch == -1)
                                return;

                            clearInterval(intv);

                            $('#js-contracts-registrations-search-input').val(contractId).trigger('input');
                        }
                    }, 900);
                }
            }, 500);
        };
        window.businessReadyFunctions.push(OnBusinessReady);
    }

    bindDOMContractCancellation() {
        let self = this;
        $(document).on('submit', '.js-contract-cancellation-form', function (e) {
            e.preventDefault();
            let formData = $(this).serializeArray();
            $('.js-contract-cancellation-form').prop('disabled', true);
            $(".modal-contract-printer-dialog").block(window._loader.loading);


            for (let i in formData) {
                let field = formData[i];
                self.contractInfo['cancel_' + field.name] = field.value;
            }

            // Confirma cancelamento e informações inseridas
            Swal.fire({
                title: 'Cancelar Contrato #' + self.contractInfo.ID,
                text: 'Deseja realmente cancelar o contrato? Fique tranquilo(a) que o contrato NÃO será removido do sistema TheQuiro! Confira as informações inseridas antes de confirmar o cancelamento.',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.js-contract-cancellation-form').prop('disabled', true);
                    $(".modal-contract-printer-dialog").block(window._loader.loading);
                    apiCall({
                        method: 'GET',
                        endpoint: 'api/v1/business/contract',
                        data: self.contractInfo,
                        successCallback: function (res) {
                            if (!res.error) {
                                $('.js-contract-cancellation-form').prop('disabled', false);

                                $(".modal-contract-printer-dialog").unblock();
                                $('.js-contract-iframe').contents().find('html').html(res.data);

                                //$('.js-contract-flow').html('');
                                //self.getContractAutentiqueFlow(contractInfo.ID, contractType);
                                self.currentContractHtml = res.data;
                                //self.currentContractID = self.contractInfo.ID;
                                //self.contractData = contractInfo;
                                //console.log('self.contractData', self.contractData);
                                self.currentContractContactData = {
                                    telefone: res.telefone,
                                    email: res.email,
                                    data_nasc: res.data_nasc,
                                    idade: res.idade
                                }
                                self.curenctContractOriginContactData = null;
                                if (typeof res.transferencia_extras.email !== 'undefined' || null) {
                                    self.curenctContractOriginContactData = res.transferencia_extras;
                                }

                                $('.js-contract-send-to-customer').removeClass('d-none');
                                if (res.data.indexOf('Para cancelar contratos com pagamento parcial') !== -1) {
                                    $('.js-contract-send-to-customer').prop('disabled', true);
                                    window.toast({
                                        error: true,
                                        text: res.data
                                    })
                                } else {
                                    $('.js-contract-send-to-customer').prop('disabled', false);
                                }
                            } else {
                                $(".modal-contract-printer-dialog").block(window._loader.error);
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-printer-dialog").block(window._loader.error);
                        }
                    });
                } else {
                    $('.js-contract-cancellation-form').prop('disabled', false);
                    $(".modal-contract-printer-dialog").unblock();
                }
            });


        });

        $(document).on('submit', '.js-contract-generation-form', function (e) {
            e.preventDefault();


            self.contractInfo['generation_finance_responsible'] = $('#contact_autentique_flow_finance_responsible').is(':checked') ? 'true' : 'false';
            self.contractInfo['generation_legal_responsible'] = self.currentContractContactData.idade < 18 ? 'true' : 'false';
            self.contractInfo['generation_finance_responsible_data'] = {
                name: $('#contact_autentique_flow_finance_responsible_name').val(),
                document: $('#contact_autentique_flow_finance_responsible_document').val(),
                birthdate: $('#contact_autentique_flow_finance_responsible_birthdate').val(),
                address: $('#contact_autentique_flow_finance_responsible_address').val(),
                number: $('#contact_autentique_flow_finance_responsible_number').val(),
                cep: $('#contact_autentique_flow_finance_responsible_cep').val(),
                neighborhood: $('#contact_autentique_flow_finance_responsible_neighborhood').val(),
                city: $('#contact_autentique_flow_finance_responsible_city').val(),
                state: $('#contact_autentique_flow_finance_responsible_state').val(),
                phone: $('#contact_autentique_flow_finance_responsible_phone').val(),
                email: $('#contact_autentique_flow_finance_responsible_email').val(),
                contactType: $('#contract_autentique_flow_contact_type_finance_responsible').val()
            }
            self.contractInfo['generation_legal_responsible_data'] = {
                name: $('#contact_autentique_flow_legal_responsible_name').val(),
                document: $('#contact_autentique_flow_legal_responsible_document').val(),
                birthdate: $('#contact_autentique_flow_legal_responsible_birthdate').val(),
                address: $('#contact_autentique_flow_legal_responsible_address').val(),
                number: $('#contact_autentique_flow_legal_responsible_number').val(),
                cep: $('#contact_autentique_flow_legal_responsible_cep').val(),
                neighborhood: $('#contact_autentique_flow_legal_responsible_neighborhood').val(),
                city: $('#contact_autentique_flow_legal_responsible_city').val(),
                state: $('#contact_autentique_flow_legal_responsible_state').val(),
                phone: $('#contact_autentique_flow_legal_responsible_phone').val(),
                email: $('#contact_autentique_flow_legal_responsible_email').val(),
                contactType: $('#contract_autentique_flow_contact_type_legal_responsible').val()
            }


            // verify if has financial responsible
            if ($('#contact_autentique_flow_finance_responsible').is(':checked')) {
                // check if contract cpf is different than financial responsible cpf
                if (parseInt($('#contact_autentique_flow_finance_responsible_document').val()) == parseInt(self.contractInfo.CPF)) {
                    return window.toast({
                        error: true,
                        text: 'O CPF do contratante não pode ser o mesmo do responsável financeiro.'
                    });
                }
            }

            if (self.contractInfo['generation_legal_responsible'] == 'true') {
                // check if contract cpf is different than legal responsible cpf
                if (parseInt($('#contact_autentique_flow_legal_responsible_document').val()) == parseInt(self.contractInfo.CPF)) {
                    return window.toast({
                        error: true,
                        text: 'O CPF do contratante não pode ser o mesmo do responsável legal.'
                    });
                }
            }

            $('.js-contract-generation-form').prop('disabled', true);
            $(".modal-contract-printer-dialog").block(window._loader.loading);

            Swal.fire({
                title: 'Gerar Contrato #' + self.contractInfo.ID,
                text: 'Deseja realmente gerar o contrato?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                reverseButtons: true
            }).then((result) => {
                if (result.isConfirmed) {
                    $('.js-contract-generation-form').prop('disabled', true);
                    $(".modal-contract-printer-dialog").block(window._loader.loading);
                    apiCall({
                        method: 'GET',
                        endpoint: 'api/v1/business/contract',
                        data: self.contractInfo,
                        successCallback: function (res) {
                            if (!res.error) {
                                $('.js-contract-generation-form').prop('disabled', false);

                                $(".modal-contract-printer-dialog").unblock();
                                $('.js-contract-iframe').contents().find('html').html(res.data);

                                //$('.js-contract-flow').html('');
                                //self.getContractAutentiqueFlow(contractInfo.ID, contractType);
                                self.currentContractHtml = res.data;
                                //self.currentContractID = self.contractInfo.ID;
                                //self.contractData = contractInfo;
                                //console.log('self.contractData', self.contractData);
                                self.currentContractContactData = {
                                    telefone: res.telefone,
                                    email: res.email,
                                    data_nasc: res.data_nasc,
                                    idade: res.idade
                                }
                                self.curenctContractOriginContactData = null;
                                if (typeof res.transferencia_extras.email !== 'undefined' || null) {
                                    self.curenctContractOriginContactData = res.transferencia_extras;
                                }

                                $('.js-contract-send-to-customer').removeClass('d-none');
                            } else {
                                $(".modal-contract-printer-dialog").block(window._loader.error);
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-printer-dialog").block(window._loader.error);
                        }
                    });
                } else {
                    $('.js-contract-generation-form').prop('disabled', false);
                    $(".modal-contract-printer-dialog").unblock();
                }
            });
        });
    }

    getContractAutentiqueFlow(contractId, contractType, isFirstRequest = true) {
        let self = this;

        if (contractType == 'quiropraxia' || contractType == 'massoterapia') {
            contractType = 'adesao';
        }

        if (isFirstRequest) {
            if (contractType == 'cancelamento' && isFirstRequest) {
                $('.js-contract-send-to-customer').addClass('d-none');
                $('.js-contract-flow').html(`
                    <div class="alert alert-danger pb-0 mt-3">
                        <h5 class="alert-heading">Atenção!</h5>
                        <p class="mb-0 text-dark">Para cancelar o contrato, preencha o formulário abaixo para gerar o termo rescisório.</p>
                        <p class="text-dark">Após gerar o termo rescisório, cadastre no Autentique, e envie para o(a) paciente.</p>
                        <p class="text-dark mb-3">Após o termo ser assinado por todas as partes, o contrato será cancelado e automaticamente será criado um chamado para reembolso do paciente.</p>
                        <form class="js-contract-cancellation-form" enctype="multipart/form-data">
                            <input type="hidden" name="contract_cancellation_contract_id" value="${contractId}">
                            <div class="row mt-3 mb-3">
                                <!-- motivo do cancelamento -->
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="contract_cancellation_obs">Motivo do Cancelamento <span class="req">*</span></label>
                                        <select name="contract_cancellation_obs" class="form-control" id="contract_cancellation_obs" required>
                                            <option value="">-- Selecione --</option>
                                            <option value="A">Desistiu - Não assinou contrato - não teve atendimento</option>
                                            <option value="B">Mudou de cidade - Mora longe</option>
                                            <option value="C">Empresa transferiu funcionário para outra cidade</option>
                                            <option value="D">Doença na família - precisa liberar limite</option>
                                            <option value="E">Motivos pessoais</option>
                                            <option value="F">Solicitação médica</option>
                                            <option value="G">Atividade encerrada na Clínica</option>
                                            <option value="H">Não consegue arcar financeiramente com contrato</option>
                                            <option value="I">Falecimento</option>
                                        </select>
                                    </div>
                                </div>
                                <!-- dados bancários do paciente para ressarcirmento -->
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="contract_cancellation_pix">Pix <span class="req">*</span></label>
                                        <input type="text" class="form-control" id="contract_cancellation_pix" name="contract_cancellation_pix" required>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="contract_cancellation_bank">Banco <span class="req">*</span></label>
                                        <input type="text" class="form-control" id="contract_cancellation_bank" name="contract_cancellation_bank" required>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="contract_cancellation_agency">Agência <span class="req">*</span></label>
                                        <input type="text" class="form-control" id="contract_cancellation_agency" name="contract_cancellation_agency" required>
                                    </div>
                                </div>

                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="contract_cancellation_account">Conta <span class="req">*</span></label>
                                        <input type="text" class="form-control" id="contract_cancellation_account" name="contract_cancellation_account" required>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="contract_cancellation_holder">Titular <span class="req">*</span></label>
                                        <input type="text" class="form-control" id="contract_cancellation_holder" name="contract_cancellation_holder" required>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="form-group">
                                        <label for="contract_cancellation_holder_cpf">CPF do Titular <span class="req">*</span></label>
                                        <input type="text" class="form-control" id="contract_cancellation_holder_cpf" name="contract_cancellation_holder_cpf" required>
                                    </div>
                                </div>
                                ${this.isAdminOrAssistant ? `
                                    <div class="col-12">
                                        <div class="form-group">
                                            <h5 class="text-dark">Os campos abaixo são opcionais, e só serão utilizados caso o cancelamento seja feito por um administrador</h5>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" id="REMOVE_MULTA_20_PORCENTO" name="REMOVE_MULTA_20_PORCENTO" value="S">
                                                <label class="form-check-label" for="REMOVE_MULTA_20_PORCENTO">Remove multa (taxa administrativa)</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <div class="form-switch">
                                                <input class="form-check-input" type="checkbox" id="CONSIDERAR_PARCIAL_MARCADO_COMO_PAGO" name="CONSIDERAR_PARCIAL_MARCADO_COMO_PAGO" value="S">
                                                <label class="form-check-label" for="CONSIDERAR_PARCIAL_MARCADO_COMO_PAGO">Considera apenas pagamentos parciais que estão marcados como pago</label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="CUSTOMIZA_VALOR_SESSAO_INDIVIDUAL">Customiza valor sessão individual</label>
                                            <input type="text" class="form-control mMoney" id="CUSTOMIZA_VALOR_SESSAO_INDIVIDUAL" name="CUSTOMIZA_VALOR_SESSAO_INDIVIDUAL">
                                        </div>
                                    </div>
                                ` : ''}
                                <div class="col-12">
                                    <button type="submit" class="btn btn-danger js-contract-cancellation-form">Gerar termo rescisório</button>
                                </div>
                            </div>
                        </form>
                    </div>
                `);
            } if (contractType == 'adesao' /*&& self.contractInfo.FILIAL_ID == 14*/) {
                $('.js-contract-send-to-customer').addClass('d-none');
                $('.js-contract-flow').html(`
                    <div class="card w-100 mt-2 border-primary">
                        <div class="card-header bg-primary text-white">
                            <h5 class="card-title mb-0 text-white text-light">
                                <i class="fas fa-file-contract me-2"></i>Geração de Contrato de Adesão
                            </h5>
                        </div>
                        <div class="card-body">
                            <div class="alert alert-info">
                                <i class="fas fa-info-circle me-2"></i>
                                <strong>Instruções:</strong> Preencha todas as informações necessárias abaixo para gerar o contrato de adesão.
                            </div>
                            
                            <form class="js-contract-generation-form" enctype="multipart/form-data">
                                <input type="hidden" name="contract_generation_contract_id" value="${contractId}">
                                
                                <!-- Financial Responsible Selection -->
                                <div class="card mb-4">
                                    <div class="card-header bg-light">
                                        <h6 class="card-title mb-0">
                                            <i class="fas fa-credit-card me-2"></i>Responsável Financeiro
                                        </h6>
                                    </div>
                                    <div class="card-body">
                                        <div class="mb-3">
                                            <label class="form-label fw-bold">
                                                <i class="fas fa-question-circle me-2 text-primary"></i>
                                                Este contrato possui responsável financeiro diferente do contratante?
                                                <span class="text-danger">*</span>
                                            </label>
                                            <div class="row mt-3">
                                                <div class="col-md-6">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="financial_responsible_choice" id="financial_responsible_yes" value="yes" required>
                                                        <label class="form-check-label fw-bold text-success" for="financial_responsible_yes">
                                                            <i class="fas fa-check-circle me-2"></i>Sim, há responsável financeiro
                                                        </label>
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-check">
                                                        <input class="form-check-input" type="radio" name="financial_responsible_choice" id="financial_responsible_no" value="no" required>
                                                        <label class="form-check-label fw-bold text-danger" for="financial_responsible_no">
                                                            <i class="fas fa-times-circle me-2"></i>Não, o contratante é o responsável financeiro
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        <!-- Hidden checkbox for existing functionality -->
                                        <div class="js-autentique-finance-responsible-switch d-none">
                                            <div class="form-group">
                                                <div class="form-check form-switch">
                                                    <input class="form-check-input" type="checkbox" id="contact_autentique_flow_finance_responsible" name="contact_autentique_flow_finance_responsible">
                                                    <label class="form-check-label" for="contact_autentique_flow_finance_responsible">Contrato possui responsável financeiro?</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <!-- Financial Responsible Form -->
                                <div class="js-autentique-finance-responsible-flow d-none">
                                    <div class="card mb-4">
                                        <div class="card-header bg-warning text-dark">
                                            <h6 class="card-title mb-0">
                                                <i class="fas fa-user-tie me-2"></i>Dados do Responsável Financeiro
                                            </h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="alert alert-warning">
                                                <i class="fas fa-exclamation-triangle me-2"></i>
                                                <strong>Atenção:</strong> O contratante não é responsável financeiro. Preencha os dados do responsável financeiro abaixo.
                                            </div>
                                            
                                            <div class="row">
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_finance_responsible_name" class="form-label">
                                                        Nome Completo <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_finance_responsible_name" name="contact_autentique_flow_finance_responsible_name" class="form-control" required>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_finance_responsible_document" class="form-label">
                                                        CPF/Passaporte <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_finance_responsible_document" name="contact_autentique_flow_finance_responsible_document" class="form-control" required>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_finance_responsible_birthdate" class="form-label">
                                                        Data de Nascimento <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="date" id="contact_autentique_flow_finance_responsible_birthdate" name="contact_autentique_flow_finance_responsible_birthdate" class="form-control" required>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_finance_responsible_phone" class="form-label">
                                                        Telefone <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_finance_responsible_phone" name="contact_autentique_flow_finance_responsible_phone" class="form-control" required>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label for="contact_autentique_flow_finance_responsible_address" class="form-label">
                                                        Endereço <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_finance_responsible_address" name="contact_autentique_flow_finance_responsible_address" class="form-control" required>
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label for="contact_autentique_flow_finance_responsible_number" class="form-label">
                                                        Número <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_finance_responsible_number" name="contact_autentique_flow_finance_responsible_number" class="form-control" required>
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label for="contact_autentique_flow_finance_responsible_cep" class="form-label">
                                                        CEP <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_finance_responsible_cep" name="contact_autentique_flow_finance_responsible_cep" class="form-control" required>
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label for="contact_autentique_flow_finance_responsible_neighborhood" class="form-label">
                                                        Bairro <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_finance_responsible_neighborhood" name="contact_autentique_flow_finance_responsible_neighborhood" class="form-control" required>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_finance_responsible_city" class="form-label">
                                                        Cidade <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_finance_responsible_city" name="contact_autentique_flow_finance_responsible_city" class="form-control" required>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_finance_responsible_state" class="form-label">
                                                        Estado <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_finance_responsible_state" name="contact_autentique_flow_finance_responsible_state" class="form-control" required>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label class="form-label">
                                                        Confirme o <span class="contact_autentique_flow_contact_type_str_finance_responsible">e-mail</span> onde o responsável financeiro irá receber o contrato para assinar <span class="text-danger">*</span>
                                                    </label>
                                                    <div class="input-group">
                                                        <select id="contract_autentique_flow_contact_type_finance_responsible" name="contract_autentique_flow_contact_type_finance_responsible" class="form-select" style="max-width: 150px;">
                                                            <option value="EMAIL" selected>E-mail</option>
                                                            <option value="SMS">SMS</option>
                                                            <option value="WHATSAPP">WhatsApp</option>
                                                        </select>
                                                        <input type="email" id="contact_autentique_flow_finance_responsible_email" name="contact_autentique_flow_finance_responsible_email" class="form-control" required>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Legal Responsible Section -->
                                <div class="js-autentique-legal-responsible-flow d-none">
                                    <div class="card mb-4">
                                        <div class="card-header bg-info text-white">
                                            <h6 class="card-title mb-0">
                                                <i class="fas fa-user-shield me-2"></i>Dados do Responsável Legal
                                            </h6>
                                        </div>
                                        <div class="card-body">
                                            <div class="alert alert-info">
                                                <i class="fas fa-exclamation-triangle me-2"></i>
                                                <strong>Atenção:</strong> Este paciente é menor de idade. É necessário informar o responsável legal.
                                            </div>
                                            
                                            <div class="row">
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_legal_responsible_name" class="form-label">
                                                        Nome Completo <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_legal_responsible_name" name="contact_autentique_flow_legal_responsible_name" class="form-control" required>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_legal_responsible_document" class="form-label">
                                                        CPF/Passaporte <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_legal_responsible_document" name="contact_autentique_flow_legal_responsible_document" class="form-control" required>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_legal_responsible_birthdate" class="form-label">
                                                        Data de Nascimento <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="date" id="contact_autentique_flow_legal_responsible_birthdate" name="contact_autentique_flow_legal_responsible_birthdate" class="form-control" required>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_legal_responsible_phone" class="form-label">
                                                        Telefone <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_legal_responsible_phone" name="contact_autentique_flow_legal_responsible_phone" class="form-control" required>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label for="contact_autentique_flow_legal_responsible_address" class="form-label">
                                                        Endereço <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_legal_responsible_address" name="contact_autentique_flow_legal_responsible_address" class="form-control" required>
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label for="contact_autentique_flow_legal_responsible_number" class="form-label">
                                                        Número <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_legal_responsible_number" name="contact_autentique_flow_legal_responsible_number" class="form-control" required>
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label for="contact_autentique_flow_legal_responsible_cep" class="form-label">
                                                        CEP <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_legal_responsible_cep" name="contact_autentique_flow_legal_responsible_cep" class="form-control" required>
                                                </div>
                                                <div class="col-md-4 mb-3">
                                                    <label for="contact_autentique_flow_legal_responsible_neighborhood" class="form-label">
                                                        Bairro <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_legal_responsible_neighborhood" name="contact_autentique_flow_legal_responsible_neighborhood" class="form-control" required>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_legal_responsible_city" class="form-label">
                                                        Cidade <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_legal_responsible_city" name="contact_autentique_flow_legal_responsible_city" class="form-control" required>
                                                </div>
                                                <div class="col-md-6 mb-3">
                                                    <label for="contact_autentique_flow_legal_responsible_state" class="form-label">
                                                        Estado <span class="text-danger">*</span>
                                                    </label>
                                                    <input type="text" id="contact_autentique_flow_legal_responsible_state" name="contact_autentique_flow_legal_responsible_state" class="form-control" required>
                                                </div>
                                                <div class="col-12 mb-3">
                                                    <label class="form-label">
                                                        Confirme o <span class="contact_autentique_flow_contact_type_str_legal_responsible">e-mail</span> onde o responsável legal irá receber o contrato para assinar <span class="text-danger">*</span>
                                                    </label>
                                                    <div class="input-group">
                                                        <select id="contract_autentique_flow_contact_type_legal_responsible" name="contract_autentique_flow_contact_type_legal_responsible" class="form-select" style="max-width: 150px;">
                                                            <option value="EMAIL" selected>E-mail</option>
                                                            <option value="SMS">SMS</option>
                                                            <option value="WHATSAPP">WhatsApp</option>
                                                        </select>
                                                        <input type="email" id="contact_autentique_flow_legal_responsible_email" name="contact_autentique_flow_legal_responsible_email" class="form-control" required>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- Submit Button -->
                                <div class="d-flex justify-content-end">
                                    <button type="submit" class="btn btn-success btn-lg">
                                        <i class="fas fa-file-contract me-2"></i>Gerar Contrato de Adesão
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                `);
            } else {
                $('.js-contract-send-to-customer').removeClass('d-none');
            }
        } else {
            $('.js-contract-flow-signatures-list').html('<tr><td colspan="5">Carregando....</td></tr>');
        }

        this.autentiqueFlowApiCall = apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/contract/autentique/current_flow',
            data: {
                contractId,
                contractType
            },
            successCallback: function (res) {
                //console.log('crud_contracts.js/patient/contract/autentique/current_flow', res);
                if (typeof res.error === 'undefined' || null) {
                    return $('.js-contract-send-to-customer').prop('disabled', false);
                }

                if (isFirstRequest) {
                    $(".modal-contract-printer-dialog").unblock();
                }

                if (res.error) {
                    if (contractType != 'cancelamento') {
                        $('.js-contract-send-to-customer').prop('disabled', false);
                    }
                } else {
                    let flowData = res.fluxos_autentique.data.document;
                    let deadLineData = res.deadLineAt.data.document;
                    $('.js-contract-flow-refresh').prop('disabled', false);

                    if (!flowData)
                        return $('.js-contract-send-to-customer').prop('disabled', false);

                    if (res.fluxos_data.STATUS === 'CANCELADO')
                        return $('.js-contract-send-to-customer').prop('disabled', false);

                    let isRejected = false,
                        isPending = false,
                        isViewed = false,
                        isCompleted = false,
                        totalSignatures = 0;

                    let rejectedCount = 0,
                        pedingCount = 0,
                        viewedCount = 0,
                        completedCount = 0;

                    for (let i in flowData.signatures) {
                        let signature = flowData.signatures[i];
                        if (signature.action !== null) {
                            totalSignatures++;
                        } else {
                            continue;
                        }

                        if (signature.rejected !== null) {
                            isRejected = true;
                            rejectedCount++;
                        }
                        if (signature.signed !== null) {
                            //isCompleted = true;
                            completedCount++;
                        }
                        if (signature.viewed !== null) {
                            isViewed = true;
                            viewedCount++;
                        }
                        if (signature.rejected == null && signature.signed == null && signature.viewed == null) {
                            isPending = true;
                            pedingCount++;
                        }
                    }

                    if (completedCount == totalSignatures) {
                        isCompleted = true;
                    }

                    /*console.log('isCompleted', isCompleted);
                    console.log('completedCount', completedCount);
                    console.log('totalSignatures', totalSignatures);*/

                    let blockTime = moment(deadLineData.deadline_at).format('DD/MM/YYYY HH:mm:ss');
                    let blockTimeUS = moment(deadLineData.deadline_at).format('YYYY-MM-DD HH:mm:ss');
                    let today = moment().format('DD/MM/YYYY');
                    let isBlockedFlow = moment().isAfter(blockTimeUS);
                    console.log('isBlockedFlow', isBlockedFlow);

                    if (deadLineData.deadline_at == null) {
                        isBlockedFlow = false;
                        blockTime = 'N/A';
                        blockTimeUS = 'N/A';
                    }

                    $('.js-contract-flow').html(`
                        <div class="row mt-3 mb-3">
                            <div class="col-12">
                                <div class="card">
                                    <div class="card-header">
                                        <h5 class="card-title
                                            ${isViewed && !isCompleted ? 'text-warning' : ''}
                                            ${isPending ? 'text-warning' : ''}
                                            ${isCompleted ? 'text-success' : ''}
                                            ${isRejected ? 'text-danger' : ''}
                                        ">
                                            <i class="fas fa-file-signature"></i> ${isRejected ? 'Contrato Rejeitado por ' + rejectedCount + ' de ' + totalSignatures + ' Signatário(s)' :
                            isPending ? 'Aguardando assinatura virtual (' + pedingCount + ' assinatura' + (pedingCount > 1 ? 's' : '') + ' pendente' + (pedingCount > 1 ? 's' : '') + ')' :
                                isCompleted ? 'Contrato Assinado (' + completedCount + ' de ' + totalSignatures + ' ' + (totalSignatures > 1 ? 's' : '') + ')' : 'Contrato Enviado'
                        }
                                        </h5>
                                    </div>
                                    <div class="card-body">
                                        <!-- Status Section -->
                                        <div class="row mb-4">
                                            <div class="col-12">
                                                ${isPending ? (`
                                                    <div class="card border-warning">
                                                        <div class="card-header bg-warning text-dark">
                                                            <h5 class="card-title mb-0">
                                                                <i class="fas fa-clock me-2"></i>Contrato Aguardando Assinaturas
                                                            </h5>
                                                        </div>
                                                        <div class="card-body">
                                                            <p class="card-text">O contrato é assinado cada signatário por vez, começando pelo(a) paciente, e somente após o(a) paciente assinar é liberado para o próximo signatário.</p>
                                                        </div>
                                                    </div>
                                                `) : ''}
                                                ${isCompleted ? (`
                                                    <div class="card border-success">
                                                        <div class="card-header bg-success text-white">
                                                            <h5 class="card-title mb-0">
                                                                <i class="fas fa-check-circle me-2"></i>Contrato Assinado
                                                            </h5>
                                                        </div>
                                                        <div class="card-body">
                                                            <p class="card-text">O contrato foi assinado por todos os signatários.</p>
                                                            <p class="card-text">Você pode baixar o contrato assinado clicando no botão abaixo.</p>
                                                        </div>
                                                    </div>
                                                `) : ''}
                                                ${isRejected ? (`
                                                    <div class="card border-danger">
                                                        <div class="card-header bg-danger text-white">
                                                            <h5 class="card-title mb-0">
                                                                <i class="fas fa-times-circle me-2"></i>Contrato Rejeitado
                                                            </h5>
                                                        </div>
                                                        <div class="card-body">
                                                            <p class="card-text">Um ou mais signatários rejeitaram o contrato.</p>
                                                            <p class="card-text">Para começar o processo de assinatura novamente, cancele e inicie o fluxo novamente.</p>
                                                        </div>
                                                    </div>
                                                `) : ''}
                                            </div>
                                        </div>

                                        <!-- Reactivation Section -->
                                        ${isCompleted && moment().isAfter(self.contractData.DATA_ENCERRAMENTO_FORMATTED) ? `
                                            <div class="row mb-4">
                                                <div class="col-12">
                                                    <div class="card border-danger">
                                                        <div class="card-header bg-danger text-white">
                                                            <h5 class="card-title mb-0">
                                                                <i class="fas fa-exclamation-triangle me-2"></i>ATENÇÃO - Contrato Expirado
                                                            </h5>
                                                        </div>
                                                        <div class="card-body">
                                                            <p class="card-text">O contrato foi assinado por todos os signatários, porém a data de encerramento do contrato já passou.</p>
                                                            <p class="card-text">Para continuar a liberação do contrato, anexe o comprovante de pagamento abaixo, insira as informações de quando o atendimento aconteceu.</p>
                                                            
                                                            <form class="js-contract-reactivation-request-form mt-3">
                                                                <input type="hidden" name="contract_reactivation_contract_id" value="${self.contractData.ID}" />
                                                                <div class="row">
                                                                    <div class="col-md-6 mb-3">
                                                                        <label for="contract_reactivation_payment_proof" class="form-label">Comprovante de Pagamento</label>
                                                                        <input type="file" name="contract_reactivation_payment_proof" class="form-control" id="contract_reactivation_payment_proof" required />
                                                                    </div>
                                                                    <div class="col-md-6 mb-3">
                                                                        <label for="contract_reactivation_obs" class="form-label">Observações</label>
                                                                        <textarea name="contract_reactivation_obs" class="form-control" id="contract_reactivation_obs" rows="3" required></textarea>
                                                                        <div class="form-text">A observação pode ser usada para constar o atendimento que o paciente por ventura tenha sido atendido e não foi lançado no sistema pois estava bloqueado. Assim o financeiro já poderá inserir esse atendimento.</div>
                                                                    </div>
                                                                </div>
                                                                <button type="submit" class="btn btn-primary">
                                                                    <i class="fas fa-paper-plane me-2"></i>Criar chamado
                                                                </button>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        `: ''}

                                        <!-- Actions Section -->
                                        <div class="row mb-4">
                                            <div class="col-12">
                                                ${!isCompleted ? (`
                                                    <div class="card border-info">
                                                        <div class="card-header bg-info text-white">
                                                            <h5 class="card-title mb-0">
                                                                <i class="fas fa-sync-alt me-2"></i>Fluxo em Andamento
                                                            </h5>
                                                        </div>
                                                        <div class="card-body">
                                                            <p class="card-text">O fluxo de assinaturas já está em andamento. Para atualizar as informações do andamento do fluxo, clique no botão abaixo:</p>
                                                            <button class="btn btn-primary js-contract-flow-refresh" data-contract-id="${contractId}" data-contract-type="${contractType}">
                                                                <i class="fas fa-sync-alt me-2"></i>Atualizar Andamento
                                                            </button>
                                                        </div>
                                                    </div>
                                                `) : ''}
                                                
                                                ${!isCompleted && !isBlockedFlow ? (`
                                                    <div class="alert alert-warning mt-3">
                                                        <strong><i class="fas fa-exclamation"></i> ATENÇÃO!</strong> O documento será bloqueado para assinaturas em ${blockTime}
                                                    </div>
                                                `) : ''}
                                                
                                                ${isBlockedFlow ? (`
                                                    <div class="alert alert-danger mt-3">
                                                        <strong><i class="fas fa-lock"></i> ATENÇÃO!</strong> O documento foi bloqueado para assinaturas em ${blockTime}
                                                    </div>
                                                `) : ''}
                                            </div>
                                        </div>

                                        <!-- Signatures Table Section -->
                                        <div class="row mb-4">
                                            <div class="col-12">
                                                <div class="card">
                                                    <div class="card-header">
                                                        <h5 class="card-title mb-0">
                                                            <i class="fas fa-users me-2"></i>Ordem de Signatários
                                                        </h5>
                                                    </div>
                                                    <div class="card-body p-0">
                                                        <div class="table-responsive">
                                                            <table class="table table-hover mb-0">
                                                                <thead class="table-light">
                                                                    <tr>
                                                                        <th class="text-center" style="width: 80px;">Ordem</th>
                                                                        <th>E-mail</th>
                                                                        <th class="text-center">Visualizado</th>
                                                                        <th class="text-center">Assinado</th>
                                                                        <th class="text-center">Rejeitado</th>
                                                                        <th class="d-none">Ações</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody class="js-contract-flow-signatures-list">
                                                                    ${flowData.signatures.map((signature, index) => {
                            if (signature.action !== null) {
                                return (`
                                                                                <tr>
                                                                                    <td class="text-center">
                                                                                        <span class="badge bg-primary rounded-pill">${index + 1}°</span>
                                                                                    </td>
                                                                                    <td>
                                                                                        <i class="fas fa-envelope me-2 text-muted"></i>
                                                                                        ${signature.email ? signature.email : '<span class="text-muted">Sem e-mail</span>'}
                                                                                    </td>
                                                                                    <td class="text-center">
                                                                                        ${signature.viewed ?
                                        `<span class="badge bg-success">${moment(signature.viewed.created_at).format('DD/MM/YYYY')}</span>` :
                                        '<span class="badge bg-secondary">Não</span>'
                                    }
                                                                                    </td>
                                                                                    <td class="text-center">
                                                                                        ${signature.signed ?
                                        `<span class="badge bg-success">${moment(signature.signed.created_at).format('DD/MM/YYYY')}</span>` :
                                        '<span class="badge bg-secondary">Não</span>'
                                    }
                                                                                    </td>
                                                                                    <td class="text-center">
                                                                                        ${signature.rejected ?
                                        `<span class="badge bg-danger">Sim</span><br><small class="text-muted">${signature.rejected.reason}</small>` :
                                        '<span class="badge bg-secondary">Não</span>'
                                    }
                                                                                    </td>
                                                                                    <td class="d-none">
                                                                                        <button class="btn btn-sm btn-outline-danger js-contract-remove-signer" datapublic-id="${signature.public_id}">
                                                                                            <i class="fas fa-trash"></i>
                                                                                        </button>
                                                                                    </td>
                                                                                </tr>
                                                                            `);
                            }
                        }).join('')}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Actions Buttons Section -->
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="d-flex flex-wrap gap-2">
                                                    <a class="btn btn-outline-primary" href="https://painel.autentique.com.br/documentos/${flowData.id}" target="_blank">
                                                        <i class="fas fa-file me-2"></i>Visualizar no Autentique
                                                    </a>
                                                    ${isCompleted && completedCount == totalSignatures ? `
                                                        <a class="btn btn-success" href="${flowData.files.signed}" target="_blank">
                                                            <i class="fas fa-download me-2"></i>Baixar Contrato Assinado
                                                        </a>
                                                    ` : ''}
                                                    ${isBlockedFlow ? `
                                                        <button class="btn btn-outline-info js-contract-unblock-autentique-flow" data-contract-id="${self.contractData.ID}">
                                                            <i class="fas fa-unlock me-2"></i>Desbloquear p/ Assinaturas
                                                        </button>
                                                    ` : ''}
                                                    ${completedCount < totalSignatures && !(self.isAdminOrAssistant) || (self.isAdminOrAssistant) ? `
                                                        <button class="btn btn-outline-danger js-contract-cancel-autentique-flow">
                                                            <i class="fas fa-times me-2"></i>Cancelar Fluxo
                                                        </button>
                                                    ` : ''}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    `);
                    $('.js-contract-send-to-customer').prop('disabled', true);
                    $('.js-contract-iframe').attr('src', flowData.files.original);
                }
            },
            errorCallback: function (err) {
                $('.js-contract-send-to-customer').prop('disabled', false);
            }
        });
    }

    bindDomTableAndFilterEvents() {
        let self = this;
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchContractsList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchContractsList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function (e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchContractsList();
        });

        // Detecta usuário mudando de filial para buscar paciente
        $('.js-contracts-registrations-branches-selector').change(function () {
            self.selectedBranch = $(this).val();
            // Caso tenha selecinado uma filial, mostra o campo para buscar pelo nome do paciente
            if (self.selectedBranch != '') {
                self.fetchContractsList();
            } else {
                self.selectedBranch = -1;
            }
        });

        // Detecta usuário buscando pelo nome do paciente
        $('#js-contracts-registrations-search-input').on('input', function () {
            let urlParams = new URLSearchParams(window.location.search);
            let contractId = urlParams.get('contract_id');

            // make a typing debounce
            clearTimeout(self.searchQueryTimeout);
            self.searchQueryTimeout = setTimeout(function () {
                self.searchQuery = $('#js-contracts-registrations-search-input').val().trim();
                if (contractId == self.searchQuery || self.searchQuery.length > 3) {
                    self.fetchContractsList();
                } else if (self.searchQuery.length == 0) {
                    self.searchQuery = '';
                    self.fetchContractsList();
                }
            }, 500);
        })

        // Detecta usuário buscando por serviço
        $('.js-contracts-services-list').change(function () {
            self.serviceId = $(this).val();
            self.fetchContractsList();
        });

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-contracts-registrations-start-date-input', function (e) {
            self.startDate = $(this).val();
            self.fetchContractsList();
        });

        // Detecta usuário configurando filtro de data de adesão
        $(document).on('change', '.js-contracts-registrations-end-date-input', function (e) {
            self.endDate = $(this).val();
            self.fetchContractsList();
        });

        // Detecta usuário configurando status do contrato
        $(document).on('change', '.js-contracts-status-list', function () {
            self.status = $(this).val();
            self.fetchContractsList();
        });

        // Detecta usuário configurando filtro qtd de registros por página
        $(document).on('change', '.js-contracts-per-page', function () {
            self.tableHandler.setRowsPerPage(parseInt($(this).val()));
            self.tableHandler.setCurrentPage(1);
            self.fetchContractsList();
        });
    }

    bindDOMContractInsert() {
        this.selectedPlanInfo = {
            serviceId: -1,
            quantity: 1,
            discount: 0,
            unitPrice: 0,
            unitPriceWithDiscount: 0,
            subtotal: 0,
            total: 0,
            dueDays: 0,
            frequency: 0,
            minUnitPrice: 0
        };
        this.contractInsertInstallments = [];
        let self = this;
        this.contractInsertPatientType = null;

        // Detecta usuário clicando no botão para "Adicionar novo contrato"
        $(".js-contracts-create-new").click(function () {
            //console.log(' self.selectedBranch',  self.selectedBranch);
            if (self.selectedBranch !== '' && self.selectedBranch !== -1) {
                $("#contract_insert_business_branch").val(self.selectedBranch).trigger('change');
                $("#contract_insert_business_branch").attr('readonly', true);

                $('#contract_insert_customer').attr('disabled', false);
            } else {
                $("#contract_insert_business_branch").val('').trigger('change');

                $("#contract_insert_business_branch").attr('readonly', false);
                $('#contract_insert_customer').attr('disabled', true);
            }

            $("#contract_insert_customer_id").val('');
            $("#contract_insert_customer").val('');
            $("#contract_insert_customer_document_id").val('');
            $("#contract_insert_customer").val('').trigger('change')


            $('#contract_insert_doctor_id').attr('disabled', true);
            $('#contract_insert_patient_type').attr('disabled', true);

            $('#contract_insert_service_type_id').attr('disabled', true);
            $('#contract_insert_service_id').attr('disabled', true);
            $('#contract_insert_plan_id').attr('disabled', true);
            $('#contract_insert_accession_date').attr('disabled', true);

            $('#contract_insert_service_discount').attr('disabled', true);
            $('#contract_insert_payment_method').attr('disabled', true);
            $('#contract_insert_obs').attr('disabled', true);
            $('#contract_insert_obs_contract').attr('disabled', true);

            $('.js-contract-insert-installments-add').attr('disabled', true);
            $('#contract_insert_combo_quiro_masso').attr('disabled', true);

            $('.js-payment-discount-warning').addClass('d-none');
            $('.js-payment-parcel-warning').addClass('d-none');

            $('.js-contract-insert-submit-button').prop('disabled', false);
            $('.js-contract-insert-applied-discount-warning').addClass('d-none');

            if (self.isPatientsPage) {
                $('#contract_insert_customer').select2({ disabled: true });
                $(`#contract_insert_customer`).html(`<option value="${self.patientInfo.ID}" selected>${self.patientInfo.NOME_COMPLETO}</option>`);
                setTimeout(() => {
                    $(`#contract_insert_customer`).val(self.patientInfo.ID).trigger('select2:select');
                }, 100);
                $("#contract_insert_customer_id").val(self.patientInfo.ID);
                $("#contract_insert_customer_document_id").val(self.patientInfo.TEM_CPF == 'S' ? self.patientInfo.CPF : self.patientInfo.PASSAPORTE);
                $('#contract_insert_doctor_id').attr('disabled', false);
            }
        });

        $('#contract_insert_business_branch').on('change', function () {
            let val = $(this).val();
            if (val !== '' && val !== -1) {
                $('#contract_insert_customer').attr('disabled', false);
            } else {
                $('#contract_insert_customer').attr('disabled', true);
                $("#contract_insert_customer_id").val('');
                $("#contract_insert_customer").val('');
                $("#contract_insert_customer_document_id").val('');
                $("#contract_insert_customer").val('').trigger('change')
            }
        });

        // Detecta usuário buscando paciente
        $('#contract_insert_customer').select2({
            placeholder: "Busque por telefone, nome ou email",
            theme: 'bootstrap-5',
            dropdownParent: $(".js-contract-insert-patient-search-container"),
            minimumInputLength: 3,
            ajax: {
                url: getBaseDir() + 'api/v1/patient/search',
                delay: 1000,
                data: function (params) {
                    var query = {
                        search: params.term,
                        branchId: $("#contract_insert_business_branch").val(),
                        page: params.page || 1
                    }
                    // Query parameters will be ?search=[term]&page=[page]
                    return query;
                },
                processResults: function (data, params) {
                    params.page = params.page || 1;

                    var results = [];
                    $.each(data.results, function (k, v) {
                        //if (v.CONTRATO_ID != null) {
                        results.push({
                            id: v.ID,
                            text: `${v.TEXT}${v.CPF != null ? ` - ${v.CPF}` : ` - ${v.PASSAPORTE}`}`,
                            info: v
                        });
                        //}
                    });

                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.count_filtered
                        }
                    };
                }
            }
        });

        // Detecta usuário selecionando paciente encontrado da busca
        $('#contract_insert_customer').on('select2:select', function (e) {
            $("#contract_insert_customer_id").val(self.isPatientsPage ? self.patientInfo.ID : e.params.data.info.ID);
            $("#contract_insert_customer").val(self.isPatientsPage ? self.patientInfo.NOME_COMPLETO : e.params.data.info.TEXT);
            $("#contract_insert_customer_document_id").val(self.isPatientsPage ? (self.patientInfo.TEM_CPF == 'S' ? self.patientInfo.CPF : self.patientInfo.PASSAPORTE) : (e.params.data.info.CPF !== null ? e.params.data.info.CPF : e.params.data.info.PASSAPORTE));

            //$("#contract_insert_business_branch").val(e.params.data.info.FILIAL_ID).trigger('change');
            //$("#contract_insert_business_branch").attr('readonly', true);

            $('#contract_insert_doctor_id').attr('disabled', false);
            $('#contract_insert_patient_type').attr('disabled', false);

            $('#contract_insert_service_type_id').attr('disabled', false);
            $('#contract_insert_service_id').attr('disabled', false);
            $('#contract_insert_plan_id').attr('disabled', false);
            $('#contract_insert_accession_date').attr('disabled', false);

            let serviceTypeId = $('#contract_insert_service_type_id').val(),
                serviceId = $('#contract_insert_service_id').val(),
                planId = $('#contract_insert_plan_id').val(),
                accessionDate = $('#contract_insert_accession_date').val();

            if (serviceTypeId != '' && serviceId != '' && planId != '' && accessionDate != '') {
                $('#contract_insert_service_discount').attr('disabled', false);
                $('#contract_insert_payment_method').attr('disabled', false);
                $('#contract_insert_obs').attr('disabled', false);
                $('#contract_insert_obs_contract').attr('disabled', false);

                $('.js-contract-insert-installments-add').attr('disabled', false);
                $('#contract_insert_combo_quiro_masso').attr('disabled', false);
            }

            let contractsWithUpload = 0;
            let contracts = self.isPatientsPage ? self.patientContracts : e.params.data.info.CONTRATOS;
            for (let i = 0; i < Object.keys(contracts).length; ++i) {
                let contract = Object.values(contracts)[i];
                if (contract.UPLOAD_CONTRATO == 'S')
                    contractsWithUpload++;
            }

            console.log('userHasRole("MANAGER")', userHasRole('MANAGER'));
            console.log('userHasRole("COMMERCIAL_ASSISTANT")', userHasRole('COMMERCIAL_ASSISTANT'));

            if (contractsWithUpload == 0) {
                self.contractInsertPatientType = getPatientTypeDataByRole('PACIENTE_INICIO_TRATAMENTO');

                let html = '<option selected default value="">-- Selecione --</option>';
                for (let i = 0; i < self.businessPlans.length; i++) {
                    let plan = self.businessPlans[i];
                    if (plan.TOTAL_PLANO > 1 && (userHasRole('MANAGER') || userHasRole('COMMERCIAL_ASSISTANT')) && userHasBranch(14))
                        continue;
                    if (
                        userHasRole('ADMIN') ||
                        userHasRole('ADMIN_ASSISTANT') ||
                        !userHasRole('ADMIN') && $("#contract_insert_business_branch").val() == 9 && plan.DESCRICAO.indexOf('Massagem') !== -1 ||
                        !userHasRole('ADMIN') /*  && plan.QT_SERVICO != 6 */
                    ) {
                        if (plan.VISIVEL == 0) continue;
                        html += `<option value='${plan.ID}' data-plan-info='${JSON.stringify(plan)}'>${plan.DESCRICAO}</option>`;
                    }
                }
                $('.js-contracts-plan-list').html(html);
            } else {
                self.contractInsertPatientType = getPatientTypeDataByRole('PACIENTE_INICIO_MANUTENCAO');

                let html = '<option selected default value="">-- Selecione --</option>';
                for (let i = 0; i < self.businessPlans.length; i++) {
                    let plan = self.businessPlans[i];
                    if (plan.TOTAL_PLANO > 1 && (userHasRole('MANAGER') || userHasRole('COMMERCIAL_ASSISTANT')) && userHasBranch(14))
                        continue;
                    //if (plan.QT_SERVICO != 6 && plan.QT_SERVICO != 12 ) {
                    if (plan.VISIVEL == 0) continue;
                    html += `<option value='${plan.ID}' data-plan-info='${JSON.stringify(plan)}'>${plan.DESCRICAO}</option>`;
                    //}
                }
                $('.js-contracts-plan-list').html(html);
            }

            //console.log('self.contractInsertPatientType', self.contractInsertPatientType);
        });

        // Detecta usuário clicando para limpar campo do paciente selecionado
        $('.js-contract-insert-clear-selected-patient').click(function () {
            $("#contract_insert_customer_id").val('');
            $("#contract_insert_customer").val('');
            $("#contract_insert_customer_document_id").val('');
            $("#contract_insert_customer").val('').trigger('change')

            $("#contract_insert_business_branch").attr('readonly', false);

            $('#contract_insert_doctor_id').attr('disabled', true);
            $('#contract_insert_patient_type').attr('disabled', true);

            $('#contract_insert_service_type_id').attr('disabled', true);
            $('#contract_insert_service_id').attr('disabled', true);
            $('#contract_insert_plan_id').attr('disabled', true);
            $('#contract_insert_accession_date').attr('disabled', true);

            $('#contract_insert_service_discount').attr('disabled', true);
            $('#contract_insert_payment_method').attr('disabled', true);
            $('#contract_insert_obs').attr('disabled', true);
            $('#contract_insert_obs_contract').attr('disabled', true);

            $('.js-contract-insert-installments-add').attr('disabled', true);
            $('#contract_insert_combo_quiro_masso').attr('disabled', true);
        });

        // Detecta clique para selecionar plano do novo contrato
        $(document).on('change', '#contract_insert_plan_id', function () {
            let PlanInfo = $('#contract_insert_plan_id option:selected').data('plan-info');
            if (PlanInfo) {
                console.log('PlanInfo', PlanInfo);
                self.selectedPlanInfo.serviceId = parseInt(PlanInfo.ID);
                self.selectedPlanInfo.quantity = parseInt(PlanInfo.QT_SERVICO);
                self.selectedPlanInfo.servicePrice = parseFloat(PlanInfo.VALOR_UNITARIO_COM_DESCONTO).toFixed(2);
                self.selectedPlanInfo.discount = 0;
                self.selectedPlanInfo.unitPrice = parseFloat(self.selectedPlanInfo.servicePrice).toFixed(2);
                self.selectedPlanInfo.unitPriceWithDiscount = parseFloat(self.selectedPlanInfo.servicePrice).toFixed(2);
                self.selectedPlanInfo.subtotal = parseFloat((self.selectedPlanInfo.unitPrice * self.selectedPlanInfo.quantity)).toFixed(2);
                self.selectedPlanInfo.total = parseFloat((self.selectedPlanInfo.unitPrice * self.selectedPlanInfo.quantity)).toFixed(2);
                self.selectedPlanInfo.dueDays = parseFloat(PlanInfo.PRAZO).toFixed(0);
                self.selectedPlanInfo.frequency = PlanInfo.FREQUENCIA;
                self.selectedPlanInfo.minUnitPrice = self.selectedPlanInfo.unitPrice;

                $("#contract_insert_service_amount").val(self.selectedPlanInfo.quantity);
                $("#contract_insert_service_due_days").val(self.selectedPlanInfo.dueDays);
                $("#contract_insert_service_discount").val(0);
                $("#contract_insert_service_unit_price").val(self.selectedPlanInfo.unitPrice);
                $("#contract_insert_service_unit_price_with_discount").val(self.selectedPlanInfo.unitPrice);
                $("#contract_insert_service_subtotal").val(self.selectedPlanInfo.total);
                $("#contract_insert_service_total").val(self.selectedPlanInfo.subtotal);
                $("#contract_insert_service_frequency").val(PlanInfo.FREQUENCIA);

                $('#contract_insert_service_type_id').val(PlanInfo.TIPO_SERVICO_ID).trigger('change');
                $('#contract_insert_service_id').val(PlanInfo.SERVICOS_ID).trigger('change');

                let accessionDate = $("#contract_insert_accession_date").val();
                let newDate = moment(accessionDate).tz("America/Sao_Paulo").add(PlanInfo.PRAZO, 'days').format("YYYY-MM-DD");
                $("#contract_insert_due_date").val(newDate);

                if (PlanInfo.MAX_DESCONTO_PERCENTUAL != null) {
                    $('.js-payment-discount-warning').removeClass('d-none');
                    $('.js-payment-discount-warning').html(`
                        <div class="alert alert-warning" role="alert">
                            <strong>ATENÇÃO!</strong> Esse plano tem o limite máximo de ${PlanInfo.MAX_DESCONTO_PERCENTUAL}% de desconto sob o valor total de tabela R$ ${PlanInfo.TOTAL_PLANO}.
                        </div>
                    `);
                } else {
                    $('.js-payment-discount-warning').addClass('d-none');
                }

                if (PlanInfo.MIN_PARCIAL_PERCENTUAL != null) {
                    $('.js-payment-parcel-warning').removeClass('d-none');
                    $('.js-payment-parcel-warning').html(`
                        <div class="alert alert-warning" role="alert">
                            <strong>ATENÇÃO!</strong> Esse plano deve ter o pagamento mínimo da parcial no valor de R$ ${PlanInfo.MIN_PARCIAL_PERCENTUAL}% sob o valor total de tabela R$ ${PlanInfo.TOTAL_PLANO}.
                        </div>
                    `);
                } else {
                    $('.js-payment-parcel-warning').addClass('d-none');
                }
            } else {
                self.selectedPlanInfo = {
                    serviceId: -1,
                    quantity: 1,
                    discount: 0,
                    unitPrice: 0,
                    unitPriceWithDiscount: 0,
                    subtotal: 0,
                    total: 0,
                    dueDays: 0
                };

                $("#contract_insert_due_date").val('');
                $('.js-payment-parcel-warning').addClass('d-none');
                $('.js-payment-discount-warning').addClass('d-none');
            }
        });

        $(document).on('change', '#contract_insert_accession_date', function () {
            let PlanInfo = $('#contract_insert_plan_id option:selected').data('plan-info');
            if (PlanInfo) {
                self.selectedPlanInfo.serviceId = parseInt(PlanInfo.ID);
                self.selectedPlanInfo.quantity = parseInt(PlanInfo.QT_SERVICO);
                self.selectedPlanInfo.servicePrice = parseFloat(PlanInfo.VALOR_UNITARIO_COM_DESCONTO).toFixed(2);
                self.selectedPlanInfo.discount = 0;
                self.selectedPlanInfo.unitPrice = parseFloat(self.selectedPlanInfo.servicePrice).toFixed(2);
                self.selectedPlanInfo.unitPriceWithDiscount = parseFloat(self.selectedPlanInfo.servicePrice).toFixed(2);
                self.selectedPlanInfo.subtotal = parseFloat((self.selectedPlanInfo.unitPrice * self.selectedPlanInfo.quantity)).toFixed(2);
                self.selectedPlanInfo.total = parseFloat((self.selectedPlanInfo.unitPrice * self.selectedPlanInfo.quantity)).toFixed(2);
                self.selectedPlanInfo.dueDays = parseFloat(PlanInfo.PRAZO).toFixed(0);

                $("#contract_insert_service_amount").val(self.selectedPlanInfo.quantity);
                $("#contract_insert_service_due_days").val(self.selectedPlanInfo.dueDays);
                $("#contract_insert_service_discount").val(0);
                $("#contract_insert_service_unit_price").val(self.selectedPlanInfo.unitPrice);
                $("#contract_insert_service_unit_price_with_discount").val(self.selectedPlanInfo.unitPrice);
                $("#contract_insert_service_subtotal").val(self.selectedPlanInfo.total);
                $("#contract_insert_service_total").val(self.selectedPlanInfo.subtotal);
                $("#contract_insert_service_frequency").val(PlanInfo.FREQUENCIA);

                let accessionDate = $("#contract_insert_accession_date").val();
                let newDate = moment(accessionDate).tz("America/Sao_Paulo").add(PlanInfo.PRAZO, 'days').format("YYYY-MM-DD");
                $("#contract_insert_due_date").val(newDate);
            }
        });

        $(document).on('change', '#contract_insert_service_type_id,#contract_insert_service_id,#contract_insert_plan_id,#contract_insert_accession_date', function () {
            let serviceTypeId = $('#contract_insert_service_type_id').val(),
                serviceId = $('#contract_insert_service_id').val(),
                planId = $('#contract_insert_plan_id').val(),
                accessionDate = $('#contract_insert_accession_date').val();

            /*console.log('detect service changes', serviceTypeId);
            console.log('detect service changes', serviceId);
            console.log('detect service changes', planId);
            console.log('detect service changes', accessionDate);*/

            if (serviceTypeId != '' && serviceId != '' && planId != '' && accessionDate != '') {
                $('#contract_insert_service_discount').attr('disabled', false);
                $('#contract_insert_payment_method').attr('disabled', false);
                $('#contract_insert_obs').attr('disabled', false);
                $('#contract_insert_obs_contract').attr('disabled', false);

                $('.js-contract-insert-installments-add').attr('disabled', false);
                $('#contract_insert_combo_quiro_masso').attr('disabled', false);
            } else {
                $('#contract_insert_service_discount').attr('disabled', true);
                $('#contract_insert_payment_method').attr('disabled', true);
                $('#contract_insert_obs').attr('disabled', true);
                $('#contract_insert_obs_contract').attr('disabled', true);

                $('.js-contract-insert-installments-add').attr('disabled', true);
                $('#contract_insert_combo_quiro_masso').attr('disabled', true);
            }
        });

        // Detecta alteração no subtotal do novo contrato
        $(document).on('change', '#contract_insert_service_subtotal', function () {
            let discountValue = $(this).val();
            self.selectedPlanInfo.subtotal = parseFloat(discountValue).toFixed(2);
            self.selectedPlanInfo.total = parseFloat(self.selectedPlanInfo.subtotal - (self.selectedPlanInfo.discount)).toFixed(2);

            checkContractMaxPercentDiscount();

            self.selectedPlanInfo.unitPrice = parseFloat(self.selectedPlanInfo.subtotal / self.selectedPlanInfo.quantity).toFixed(2);
            self.selectedPlanInfo.unitPriceWithDiscount = parseFloat(self.selectedPlanInfo.total / self.selectedPlanInfo.quantity).toFixed(2);

            $("#contract_insert_service_unit_price").val(self.selectedPlanInfo.unitPrice);
            $("#contract_insert_service_unit_price_with_discount").val(self.selectedPlanInfo.unitPriceWithDiscount);
            $("#contract_insert_service_subtotal").val(self.selectedPlanInfo.subtotal);
            $("#contract_insert_service_total").val(self.selectedPlanInfo.total);
        });

        // Detecta alteração no valor da sessão individual com desconto
        // Quando o preço unitário com desconto é alterado
        $(document).on('change', '#contract_insert_service_unit_price_with_discount', function (e) {
            e.preventDefault();
            e.stopPropagation();
            let discountValue = $(this).val();
            if (discountValue?.trim() == '' || isNaN(discountValue)) {
                discountValue = 0;
            }

            if (parseFloat(discountValue).toFixed(2) < parseFloat(self.selectedPlanInfo.minUnitPrice).toFixed(2)) {
                $(this).val(self.selectedPlanInfo.minUnitPrice);
                return window.toast({
                    error: true,
                    text: `O valor da sessão individual com desconto não pode ser menor que o valor mínimo do plano de R$ ${self.selectedPlanInfo.minUnitPrice}.`
                });
            }

            // Atualiza o preço unitário com desconto
            self.selectedPlanInfo.unitPriceWithDiscount = parseFloat(discountValue).toFixed(2);

            // Zera o desconto quando o preço unitário com desconto é alterado
            self.selectedPlanInfo.discount = 0;

            // Calcula o subtotal e total baseado apenas no preço unitário com desconto
            self.selectedPlanInfo.subtotal = parseFloat((self.selectedPlanInfo.unitPriceWithDiscount * self.selectedPlanInfo.quantity)).toFixed(2);
            self.selectedPlanInfo.total = self.selectedPlanInfo.subtotal;

            // Atualiza os campos no formulário
            $('#contract_insert_service_discount').val(0);
            $("#contract_insert_service_subtotal").val(self.selectedPlanInfo.subtotal);
            $("#contract_insert_service_total").val(self.selectedPlanInfo.total);

            $('.js-contract-insert-applied-discount-warning').addClass('d-none');
        });

        // Detecta alteração no desconto do novo contrato
        $(document).on('change', '#contract_insert_service_discount', function () {
            let discountValue = $(this).val();
            if (discountValue?.trim() == '' || isNaN(discountValue)) {
                discountValue = 0;
            }

            if (parseFloat(discountValue) < 0) {
                $(this).val(0);
                return window.toast({
                    error: true,
                    text: 'O desconto não pode ser negativo. Se quiser aumentar o preço da sessão, altere o valor unitário com desconto.'
                });
            }

            // Atualiza o desconto
            self.selectedPlanInfo.discount = parseFloat(discountValue).toFixed(2);

            // Calcula o total subtraindo o desconto do subtotal
            self.selectedPlanInfo.total = parseFloat(self.selectedPlanInfo.subtotal - self.selectedPlanInfo.discount).toFixed(2);

            // Atualiza o preço unitário com desconto baseado no novo total
            self.selectedPlanInfo.unitPriceWithDiscount = parseFloat(self.selectedPlanInfo.total / self.selectedPlanInfo.quantity).toFixed(2);

            // Atualiza os campos no formulário
            $("#contract_insert_service_unit_price_with_discount").val(self.selectedPlanInfo.unitPriceWithDiscount);
            $("#contract_insert_service_total").val(self.selectedPlanInfo.total);
            $('#contract_insert_service_discount').val(0);
            $('.js-contract-insert-applied-discount-warning').removeClass('d-none');
            $('.js-contract-insert-applied-discount-warning').html(`
                <div class="alert alert-warning" role="alert">
                    <strong>ATENÇÃO!</strong> O desconto aplicado é de R$ ${self.selectedPlanInfo.discount}.
                </div>
            `);
        });

        // Detecta clique para criar novo contrato
        $(document).on('submit', '.js-contract-create-form', function (e) {
            e.preventDefault();

            /*let hasCombo = $('#contract_insert_combo_quiro_masso').val() == 1;
            if (hasCombo) {
                let value = $(this).val();
                let sum = parseFloat(value) + parseFloat($('#contract_insert_combo_quiro_masso_price').val());
                console.log('sum', sum);
                console.log('contract_insert_service_unit_price_with_discount', $('#contract_insert_service_unit_price_with_discount').val());
                if (isNaN(sum)) {
                    return $('.js-contract-insert-submit-button').prop('disabled', true);
                }
                if (sum < $('#contract_insert_service_unit_price_with_discount').val() || sum > $('#contract_insert_service_unit_price_with_discount').val()) {
                    $('.js-contract-insert-submit-button').prop('disabled', true);
                    return window.toast({
                        error: true,
                        text: 'O valor da soma dos serviços de combo não pode ser diferente do "Preço unitário com desconto" do serviço principal.'
                    });
                } else {
                    $('.js-contract-insert-submit-button').prop('disabled', false);
                }
            }*/

            if (/*$("#contract_insert_customer").val() == null || */$("#contract_insert_customer_id").val() == '') {
                return window.toast({
                    error: true,
                    text: "Por favor, selecione um paciente."
                });
            }

            if (self.contractInsertInstallments.length > 0) {
                checkContractMinParcelAmount();
            }

            let serializeData = $(this).serializeArray();
            $(".modal-contract-create-dialog").block(window._loader.loading);

            let selfBtn = this;
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            serializeData.push({
                name: 'contract_insert_installments',
                value: JSON.stringify(self.contractInsertInstallments)
            });

            Swal.fire({
                title: 'Criar novo contrato?',
                text: 'Antes de continuar confirme as informações inseridas, caso esteja tudo certo, basta continuar.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6'
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/patient/new_contract',
                        data: serializeData,
                        successCallback: function (res) {
                            $(".modal-contract-create-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                            window.toast({
                                error: res.error,
                                text: res.message
                            })

                            if (!res.error) {
                                $('#contract_insert_combo_quiro_masso_sessions').prop('required', false);
                                $('#contract_insert_combo_quiro_price').prop('required', false);
                                $('#contract_insert_combo_quiro_masso_price').prop('required', false);
                                $('#contract_insert_service_2_id').prop('required', false);
                                $('#contract_insert_doctor_2_id').prop('required', false);
                                $('.js-contract-create-form').trigger('reset');
                                $('#modal-contract-create').modal('hide');
                                self.fetchContractsList();
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-create-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                        }
                    })
                } else {
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                }
            });
        });

        $(document).on('click', '.js-contract-sessions-toggler', function () {
            let contractId = $(this).data('contract-id');
            let branchId = $(this).data('branch-id');
            // open tr with sessions
            $(`.js-contract-sessions-${contractId}`).toggleClass('d-none');
            if ($(`.js-contract-sessions-${contractId}`).hasClass('d-none')) {
                $(`.js-contract-sessions-btn-${contractId}`).html(`<i class="fas fa-eye"></i> Ver sessões`);
                $(`js-contract-sessions-list-${contractId}`).html(`
                    <!-- spinner -->
                    <div class="d-flex justify-content-center">
                        <div class="spinner-border" role="status">
                            <span class="visually-hidden">Carregando...</span>
                        </div>
                    </div>
                `);
            } else {
                self.fetchContractSessions(contractId, branchId);
                $(`.js-contract-sessions-btn-${contractId}`).html(`<i class="fas fa-eye-slash"></i> Esconder sessões`);
                $(`.js-contract-sessions-btn-${contractId}`).prop('disabled', true);
            }
        });

        $(document).on('submit', '.js-contract-insert-installments-form', function (e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            //console.log(serializeData);

            let id = self.contractInsertInstallments.length + 1;
            self.contractInsertInstallments.push({
                ID: id,
                FORMA_PAGAMENTO: serializeData.find(item => item.name === 'contract_insert_installments_payment_method').value,
                DATA_PAGAMENTO: serializeData.find(item => item.name === 'contract_insert_installments_payment_date').value,
                QT_PARCELAS: serializeData.find(item => item.name === 'contract_insert_installments_installments').value,
                VALOR_PARCELA: serializeData.find(item => item.name === 'contract_insert_installments_installment_value').value,
                VALOR_TOTAL: serializeData.find(item => item.name === 'contract_insert_installments_total').value,
                OBSERVACAO: serializeData.find(item => item.name === 'contract_insert_installments_obs').value,
            });
            $('.js-contract-insert-installments-list').html(renderContractInsertInstallments());
        });

        $(document).on('click', '.js-contract-insert-installments-remove', function () {
            let installmentId = $(this).data('installment-id');
            self.contractInsertInstallments = self.contractInsertInstallments.filter(installment => installment.ID !== installmentId);
            $('.js-contract-insert-installments-list').html(renderContractInsertInstallments());
        });

        $(document).on('change', '#contract_insert_combo_quiro_masso', function () {
            let value = $(this).val();
            if (value == 1) {
                $('.js-contract-insert-combo-quiro-masso').removeClass('d-none');
                $('#contract_insert_combo_quiro_masso_sessions').prop('required', true);
                $('#contract_insert_combo_quiro_price').prop('required', true);
                $('#contract_insert_combo_quiro_masso_price').prop('required', true);
                $('#contract_insert_service_2_id').prop('required', true);
                $('#contract_insert_doctor_2_id').prop('required', true);
                $('#contract_insert_combo_quiro_masso_sessions').val($('#contract_insert_service_amount').val() || 1);
                //$('.js-contract-insert-submit-button').prop('disabled', true);
            } else {
                $('.js-contract-insert-combo-quiro-masso').addClass('d-none');
                $('#contract_insert_combo_quiro_masso_sessions').prop('required', false);
                $('#contract_insert_combo_quiro_price').prop('required', false);
                $('#contract_insert_combo_quiro_masso_price').prop('required', false);
                $('#contract_insert_service_2_id').prop('required', false);
                $('#contract_insert_doctor_2_id').prop('required', false);
                $('.js-contract-insert-submit-button').prop('disabled', false);
            }
        });

        $(document).on('change', '#contract_insert_combo_quiro_price', function () {
            let hasCombo = $('#contract_insert_combo_quiro_masso').val() == 1;
            if (hasCombo) {
                /*let value = $(this).val();
                let sum = Number(value) + Number($('#contract_insert_combo_quiro_masso_price').val());
                console.log('sum', sum);
                console.log('contract_insert_service_unit_price_with_discount', $('#contract_insert_service_unit_price_with_discount').val());
                if (isNaN(sum)) {
                    return $('.js-contract-insert-submit-button').prop('disabled', true);
                }
                if (sum < $('#contract_insert_service_unit_price_with_discount').val() || sum > $('#contract_insert_service_unit_price_with_discount').val()) {
                    $('.js-contract-insert-submit-button').prop('disabled', true);
                    window.toast({
                        error: true,
                        text: 'O valor da soma dos serviços de combo não pode ser diferente do "Preço unitário com desconto" do serviço principal.'
                    });
                } else {
                    $('.js-contract-insert-submit-button').prop('disabled', false);
                }*/
            }
        });

        $(document).on('change', '#contract_insert_combo_quiro_masso_price', function () {
            let hasCombo = $('#contract_insert_combo_quiro_masso').val() == 1;
            if (hasCombo) {
                /*let value = $(this).val();
                let sum = parseFloat(value) + parseFloat($('#contract_insert_combo_quiro_price').val());
                console.log('sum', sum);
                console.log('contract_insert_service_unit_price_with_discount', $('#contract_insert_service_unit_price_with_discount').val());
                if (isNaN(sum)) {
                    return $('.js-contract-insert-submit-button').prop('disabled', true);
                }
                if (sum < $('#contract_insert_service_unit_price_with_discount').val() || sum > $('#contract_insert_service_unit_price_with_discount').val()) {
                    $('.js-contract-insert-submit-button').prop('disabled', true);
                    window.toast({
                        error: true,
                        text: 'O valor da soma dos serviços de combo não pode ser diferente do "Preço unitário com desconto" do serviço principal.'
                    });
                } else {
                    $('.js-contract-insert-submit-button').prop('disabled', false);
                }*/
            }
        });

        function renderContractInsertInstallments() {
            let html = '';
            self.contractInsertInstallments.forEach(installment => {
                html += `
                    <tr>
                        <td data-label="Ações">
                            <button class="btn btn-danger js-contract-insert-installments-remove" type="button" data-installment-id="${installment.ID}">
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                        <td data-label="Forma de Pagamento">${getPaymentMethod(installment.FORMA_PAGAMENTO)}</td>
                        <td data-label="Data de Pagamento">${installment.DATA_PAGAMENTO}</td>
                        <td data-label="Quantidade de Parcelas">${installment.QT_PARCELAS}</td>
                        <td data-label="Valor da Parcela">${installment.VALOR_PARCELA}</td>
                        <td data-label="Valor Total">${installment.VALOR_TOTAL}</td>
                        <td data-label="Observação">${installment.OBSERVACAO}</td>
                    </tr>
                `;
            });
            return html;
        }

        function checkContractMaxPercentDiscount() {

            let findPlan = self.businessPlans.find((obj) => obj.ID == self.selectedPlanInfo.serviceId);
            if (findPlan) {
                let maxPercentDiscount = parseFloat(findPlan.MAX_DESCONTO_PERCENTUAL).toFixed(2),
                    //planDefaultPrice = parseFloat(findPlan.TOTAL_PLANO).toFixed(2),
                    maxDiscountPrice = ((maxPercentDiscount / 100) * findPlan.TOTAL_PLANO);

                if (findPlan.MAX_DESCONTO_PERCENTUAL !== null) {
                    //console.log('checkContractMaxPercentDiscount', 'self.selectedPlanInfo.serviceId',  self.selectedPlanInfo.serviceId);
                    //console.log('checkContractMaxPercentDiscount', 'findPlan', findPlan);
                    //console.log('checkContractMaxPercentDiscount', 'self.selectedPlanInfo.total', self.selectedPlanInfo.total);
                    //console.log('checkContractMaxPercentDiscount', 'planDefaultPrice', planDefaultPrice);
                    //console.log('checkContractMaxPercentDiscount', 'maxDiscountPrice', maxDiscountPrice);

                    if (self.selectedPlanInfo.discount > maxDiscountPrice) {
                        self.selectedPlanInfo.discount = 0;
                        self.selectedPlanInfo.unitPrice = parseFloat(self.selectedPlanInfo.servicePrice).toFixed(2);
                        self.selectedPlanInfo.unitPriceWithDiscount = parseFloat(self.selectedPlanInfo.servicePrice).toFixed(2);
                        self.selectedPlanInfo.subtotal = parseFloat((self.selectedPlanInfo.unitPrice * self.selectedPlanInfo.quantity)).toFixed(2);
                        self.selectedPlanInfo.total = parseFloat((self.selectedPlanInfo.unitPrice * self.selectedPlanInfo.quantity)).toFixed(2);

                        $("#contract_insert_service_amount").val(self.selectedPlanInfo.quantity);
                        $("#contract_insert_service_discount").val(0);
                        $("#contract_insert_service_unit_price").val(self.selectedPlanInfo.unitPrice);
                        $("#contract_insert_service_unit_price_with_discount").val(self.selectedPlanInfo.unitPrice);
                        $("#contract_insert_service_subtotal").val(self.selectedPlanInfo.total);
                        $("#contract_insert_service_total").val(self.selectedPlanInfo.subtotal);

                        return window.toast({
                            error: true,
                            text: 'O desconto máximo desse plano é de R$ ' + maxDiscountPrice + ''
                        });
                    }
                }
            }
        }

        function checkContractMinParcelAmount() {
            let findPlan = self.businessPlans.find((obj) => obj.ID == self.selectedPlanInfo.serviceId);
            if (findPlan) {
                let minPercentParcel = parseFloat(findPlan.MIN_PARCIAL_PERCENTUAL).toFixed(2),
                    //planDefaultPrice = parseFloat(findPlan.TOTAL_PLANO).toFixed(2),
                    minSumParcels = ((minPercentParcel / 100) * findPlan.TOTAL_PLANO);

                if (findPlan.MIN_PARCIAL_PERCENTUAL !== null) {
                    let sumTotalParcels = 0;
                    for (let i = 0; i < self.contractInsertInstallments.length; ++i) {
                        sumTotalParcels += parseFloat(self.contractInsertInstallments[i].VALOR_TOTAL).toFixed(2);
                    }

                    if (sumTotalParcels < minSumParcels) {
                        return window.toast({
                            error: true,
                            text: `O valor mínimo de parcial deste plano é de R$ ${minSumParcels}.`
                        })
                    }

                    //console.log('sumTotalParcels', sumTotalParcels);
                    //console.log('minPercentParcel', minPercentParcel);
                    //console.log('minSumParcels', minSumParcels);
                }
            }
        }
    }

    bindDOMContractUpdate() {
        let self = this;

        // Detecta alteração básica do contrato
        $(document).on('submit', '.js-contract-basic-update-form', function (e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            $(".modal-contract-basic-update-dialog").block(window._loader.loading);

            let selfBtn = this;
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/update_contract',
                data: serializeData,
                successCallback: function (res) {
                    $(".modal-contract-basic-update-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                    window.toast({
                        error: res.error,
                        text: res.message
                    })

                    if (!res.error) {
                        $('.js-contract-basic-update-form').trigger('reset');
                        $('#modal-contract-basic-update').modal('hide');
                        self.fetchContractsList();
                    }
                },
                errorCallback: function (err) {
                    $(".modal-contract-basic-update-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                }
            })
        });

        // Detecta alteração de comissão do contrato
        $(document).on('submit', '.js-contract-commision-form', function (e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            $(".modal-contract-commision-dialog").block(window._loader.loading);

            let selfBtn = this;
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/contract/update_commision',
                data: serializeData,
                successCallback: function (res) {
                    $(".modal-contract-commision-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                    window.toast({
                        error: res.error,
                        text: res.message
                    })

                    if (!res.error) {
                        $('.js-contract-commision-update-form').trigger('reset');
                        $('#modal-contract-commision-update').modal('hide');
                        self.fetchContractsList();
                    }
                },
                errorCallback: function (err) {
                    $(".modal-contract-commision-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                }
            })
        });

        // Detecta alteração avançada do contrato
        $(document).on('click', '.js-contract-advanced-update', function (e) {
            e.preventDefault();
            let contractData = $(this).data('contract-info');
            self.selectedContractAdvancedUpdates = contractData;

            $('#contract_advanced_insert_installments_contract_id').val(contractData.ID);
            $('#contract_advanced_update_business_branch').val(contractData.FILIAL_ID);
            $('#contract_advanced_update_service_type_id').val(contractData.TIPO_SERVICO_ID);
            $('#contract_advanced_update_customer').val(contractData.CLIENTE_ID);
            $('#contract_advanced_update_customer_document_id').val(contractData.CPF);
            $('#contract_advanced_update_accession_date').val(contractData.DATA_ADESAO_FORMATTED);
            $('#contract_advanced_update_plan_id').val(contractData.PLANOS_ID);
            $('#contract_advanced_update_service_amount').val(contractData.QT_SERVICO);
            $('#contract_advanced_update_service_id').val(contractData.SERVICO_ID);
            $('#contract_advanced_update_service_due_days').val(contractData.PRAZO);
            $('#contract_advanced_update_service_frequency').val(contractData.FREQUENCIA);
            $('#contract_advanced_update_due_date').val(contractData.DATA_ENCERRAMENTO_FORMATTED);
            $('#contract_advanced_update_service_unit_price').val(contractData.PRECO_UNITARIO);
            $('#contract_advanced_update_service_subtotal').val(contractData.TOTAL);
            $('#contract_advanced_update_service_discount').val(contractData.DESCONTO_VALOR);
            $('#contract_advanced_update_service_unit_price_with_discount').val(contractData.VALOR_UNITARIO_COM_DESCONTO);
            $('#contract_advanced_update_service_total').val(contractData.TOTAL_PLANO);
            $('#contract_advanced_update_doctor_id').val(contractData.DOUTOR_ID);
            $('#contract_advanced_update_patient_type').val(contractData.TIPO_PACIENTE_ID);
            $('#contract_advanced_update_payment_method').val(contractData.FORMA_PAGAMENTO);
            $('#contract_advanced_update_obs').val(contractData.OBSERVACAO);
            $('#contract_advanced_update_obs_contract').val(contractData.CONTRATO);

            self.fetchContractInstallments(self.selectedContractAdvancedUpdates.ID);
            self.fetchContractLogs(self.selectedContractAdvancedUpdates.ID);
        });

        // Detecta inserção de parcela de um contrato
        $(document).on('submit', '.js-contract-advanced-insert-installments-form', function (e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            $(".modal-contract-advanced-insert-installments-dialog").block(window._loader.loading);

            let selfBtn = this;
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/contract/insert_installment',
                data: serializeData,
                successCallback: function (res) {
                    $(".modal-contract-advanced-insert-installments-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                    window.toast({
                        error: res.error,
                        text: res.message
                    })

                    if (!res.error) {
                        $('.js-contract-advanced-insert-installments-form').trigger('reset');
                        $('#contract_advanced_insert_installments_contract_id').val(self.selectedContractAdvancedUpdates.ID);
                        $('#modal-contract-advanced-insert-installments').modal('hide');
                        self.fetchContractInstallments(self.selectedContractAdvancedUpdates.ID);
                    }
                },
                errorCallback: function (err) {
                    $(".modal-contract-advanced-insert-installments-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                }
            })
        });

        $(document).on('click', '.js-contract-advanced-update-installment', function (e) {
            e.preventDefault();
            let installmentData = $(this).data('installment-info');
            self.selectedContractAdvancedInstallment = installmentData;
            $('.js-contract-advanced-insert-installment-payment-attachment-form').trigger('reset');
            $('#modal-contract-advanced-insert-installment-payment-attachment').modal('show');
        });

        $(document).on('submit', '.js-contract-advanced-insert-installment-payment-attachment-form', function (e) {
            e.preventDefault();
            let formData = new FormData(this)

            Swal.fire({
                title: 'Confirmação',
                text: 'Deseja realmente inserir o comprovante de pagamento para esta parcela? Este anexo criará um chamado para a equipe de suporte verificar a autenticidade do comprovante e dar baixa do pagamento.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6'
            }).then((result) => {
                if (result.isConfirmed) {

                    $(".modal-contract-advanced-insert-installment-payment-attachment-dialog").block(window._loader.loading);

                    formData.append('contract_id', self.selectedContractAdvancedUpdates.ID);
                    formData.append('installment_id', self.selectedContractAdvancedInstallment.ID);

                    let selfBtn = this;
                    $(selfBtn).find('button[type="submit"]').prop('disabled', true);

                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/patient/contract/insert_installment_payment_attachment',
                        data: formData,
                        processData: false,
                        contentType: false,
                        successCallback: function (res) {
                            $(".modal-contract-advanced-insert-installment-payment-attachment-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                            window.toast({
                                error: res.error,
                                text: res.message
                            })

                            if (!res.error) {
                                $('.js-contract-advanced-insert-installment-payment-attachment-form').trigger('reset');
                                $('#modal-contract-advanced-insert-installment-payment-attachment').modal('hide');
                                self.fetchContractInstallments(self.selectedContractAdvancedUpdates.ID);

                                Swal.fire({
                                    title: 'Sucesso',
                                    text: 'Comprovante de pagamento inserido com sucesso. O chamado para verificar a autenticidade do comprovante foi criado, por favor aguarde a resposta da equipe de suporte.',
                                    icon: 'success'
                                });
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-advanced-insert-installment-payment-attachment-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                        }
                    })
                }
            });
        });

        $(document).on('submit', '.js-contract-180-day-unlock-form', function (e) {
            e.preventDefault();
            let formData = new FormData(this)

            Swal.fire({
                title: 'Confirmação',
                text: 'Deseja realmente inserir o comprovante de pagamento de reavaliação para este contrato? Este anexo criará um chamado para a equipe de suporte verificar a autenticidade do comprovante e dar baixa do pagamento.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6'
            }).then((result) => {
                if (result.isConfirmed) {

                    $(".modal-contract-180-day-unlock-dialog").block(window._loader.loading);

                    formData.append('contract_id', self.selectedContractAdvancedUpdates.ID);
                    //formData.append('installment_id', self.selectedContractAdvancedInstallment.ID);

                    let selfBtn = this;
                    $(selfBtn).find('button[type="submit"]').prop('disabled', true);

                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/patient/contract/insert_180_day_unlock_payment_attachment',
                        data: formData,
                        processData: false,
                        contentType: false,
                        successCallback: function (res) {
                            $(".modal-contract-180-day-unlock-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                            window.toast({
                                error: res.error,
                                text: res.message
                            })

                            if (!res.error) {
                                $('.js-contract-180-day-unlock-form').trigger('reset');
                                $('#modal-contract-180-day-unlock').modal('hide');

                                Swal.fire({
                                    title: 'Sucesso',
                                    text: res.message,
                                    icon: 'success'
                                });
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-180-day-unlock-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                        }
                    })
                }
            });
        });
    }

    bindDOMContractTransfer() {
        let self = this;
        $('.js-contract-transfer-form').on('submit', function (e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            $(".modal-contract-transfer-dialog").block(window._loader.loading);

            serializeData.push({
                name: 'contract_transfer_source_contract',
                value: self.selectedContractForTransfer
            });
            serializeData.push({
                name: 'contract_transfer_branch_id',
                value: self.selectedContractForTransfer.FILIAL_ID
            });
            serializeData.push({
                name: 'contract_transfer_sessions_attended',
                value: $("#contract_transfer_sessions_attedend").text()
            });
            serializeData.push({
                name: 'contract_transfer_sessions_scheduled',
                value: $("#contract_transfer_sessions_scheduled").text()
            });
            serializeData.push({
                name: 'contract_transfer_sessions_open',
                value: $("#contract_transfer_sessions_open").text()
            });

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/contract/transfer',
                data: serializeData,
                successCallback: function (res) {
                    $(".modal-contract-transfer-dialog").unblock();

                    window.toast({
                        error: res.error,
                        text: res.message
                    })

                    if (!res.error) {
                        $('.js-contract-transfer-form').trigger('reset');
                        $('#modal-contract-transfer').modal('hide');
                        self.fetchContractsList();
                    }
                },
                errorCallback: function (err) {
                    $(".modal-contract-transfer-dialog").unblock();
                }
            })
        });
    }

    bindDOMContractUploads() {
        this.selectedContractForUploads = null;
        let self = this;

        // Detecta clique para visualizar lista de uploads de um contrato
        $(document).on('click', '.js-contract-uploads', function () {
            let contractData = $(this).data('contract-info');
            self.selectedContractForUploads = contractData;
            self.fetchCurrentContractViewUploads(contractData.ID);
        });

        // Detecta clique para subir um contrato do paciente
        $(document).on('submit', '.js-contract-upload-form', function (e) {
            e.preventDefault();
            let botEditData = new FormData(this);
            botEditData.append('contract_id', self.selectedContractForUploads.ID);

            let selfBtn = this;
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/contract/upload',
                data: botEditData,
                processData: false,
                contentType: false,
                formBlockContainer: ".modal-contract-upload-dialog",
                formElement: '.js-contract-upload-form',
                successCallback: function (body) {
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                    window.toast({
                        error: body.error,
                        text: body.message
                    });

                    if (!body.error) {
                        $('.js-contract-upload-form').trigger('reset');
                        self.fetchCurrentContractViewUploads(self.selectedContractForUploads.ID);
                    }
                },
                errorCallback: function (err) {
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                    console.log('crud_contracts.js/patient/contract/upload', err);
                }
            });
        });

        // Detecta clique para excluir um contrato registrado
        $(document).on('click', '.js-contract-delete-upload-file', function () {
            let uploadId = $(this).data('upload-id'),
                contractId = $(this).data('contract-id');

            if (!userHasRole('ADMIN'))
                return window.toast({
                    error: true,
                    text: 'Apenas administradores podem remover Contratos.'
                })

            if (!window.confirm('Deseja realmente excluir este arquivo?')) {
                return;
            }

            apiCall({
                method: 'POST',
                endpoint: 'api/v1/patient/contract/upload_delete',
                data: {
                    upload_id: uploadId,
                    contract_id: contractId
                },
                successCallback: function (body) {
                    window.toast({
                        error: body.error,
                        text: body.message
                    });

                    if (!body.error) {
                        self.fetchCurrentContractViewUploads(contractId);
                    }
                },
                errorCallback: function (err) {
                    console.log('crud_contracts.js/patient/contract/upload_delete', err);
                }
            })
        });
    }

    bindDOMContractReactivation() {
        let self = this;

        $(document).on('click', '.js-contract-financial-reactivation', function () {
            let contractData = $(this).data('contract-info');
            self.selectedContractForReactivation = contractData;

            $("#contract_reactivation_contract_id").val(contractData.ID);
            $("#contract_reactivation_patient").val(contractData.CLIENTE_NOME);
            $("#contract_reactivation_date").val(moment(contractData.DATA_ADESAO_FORMATTED).format('YYYY-MM-DD'));
            $("#contract_reactivation_end_date").val(moment(contractData.DATA_ENCERRAMENTO_FORMATTED).format('YYYY-MM-DD'));
            $("#contract_reactivation_new_end_date").val('');
        });

        $(document).on('change', '#contract_reactivation_time', function () {
            let months = $(this).val();
            let end_date = $('#contract_reactivation_end_date').val();
            let today = moment().format('YYYY-MM-DD');
            let endDate = moment(
                moment(end_date).isAfter(today) ? end_date : self.selectedContractForReactivation.DATA_ENCERRAMENTO_FORMATTED
            ).add(months, 'months').format('YYYY-MM-DD');
            $("#contract_reactivation_new_end_date").val(moment(endDate).format('DD/MM/YYYY'));
        });

        $(document).on('submit', '.js-contract-reactivation-form', function (e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            let selfBtn = $('.js-contract-reactivation-form').find('button[type="submit"]');
            $(".modal-contract-financial-unlock-dialog").block(window._loader.loading);

            Swal.fire({
                title: 'Confirmação',
                text: 'Deseja realmente reativar este contrato? Esta ação irá reativar o contrato e permitir que o paciente continue utilizando os serviços.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6'
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/patient/contract/reactivate',
                        data: serializeData,
                        successCallback: function (res) {
                            $(".modal-contract-financial-unlock-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                            window.toast({
                                error: res.error,
                                text: res.message
                            })

                            if (!res.error) {
                                $('.js-contract-reactivation-form').trigger('reset');
                                $('#modal-contract-financial-unlock').modal('hide');
                                self.fetchContractsList();
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-financial-unlock-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                        }
                    })
                } else {
                    $(".modal-contract-financial-unlock-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                }
            });
        });
    }

    bindDOMContractFinancialChanges() {
        let self = this;
        $(document).on('click', '.js-contract-financial-advanced-changes', function () {
            let contractData = $(this).data('contract-info');
            self.selectedContractForFinancialChanges = contractData;

            $("#contract_financial_advanced_changes_contract_id").val(contractData.ID);
            $("#contract_financial_advanced_changes_patient").val(contractData.CLIENTE_NOME);
            $("#contract_financial_advanced_changes_payment_method").val(contractData.FORMA_PAGAMENTO);
            $("#contract_financial_advanced_changes_obs").val(contractData.OBSERVACAO);
            $("#contract_financial_accession_date").val(moment(contractData.DATA_ADESAO_FORMATTED).format('YYYY-MM-DD'));
            $("#contract_financial_due_date").val(moment(contractData.DATA_ENCERRAMENTO_FORMATTED).format('YYYY-MM-DD'));
        });

        $(document).on('submit', '.js-contract-financial-advanced-changes-form', function (e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            let selfBtn = $('.js-contract-financial-advanced-changes-form').find('button[type="submit"]');
            $(".modal-contract-financial-advanced-changes-dialog").block(window._loader.loading);

            Swal.fire({
                title: 'Confirmação',
                text: 'Deseja realmente aplicar as alterações financeiras deste contrato? Esta ação irá alterar a forma de pagamento e a data de vencimento do contrato.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6'
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/patient/contract/financial_changes',
                        data: serializeData,
                        successCallback: function (res) {
                            $(".modal-contract-financial-advanced-changes-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);

                            window.toast({
                                error: res.error,
                                text: res.message
                            })

                            if (!res.error) {
                                $('.js-contract-financial-advanced-changes-form').trigger('reset');
                                $('#modal-contract-financial-advanced-changes').modal('hide');
                                self.fetchContractsList();
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-financial-advanced-changes-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                        }
                    })
                } else {
                    $(".modal-contract-financial-advanced-changes-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                }
            });
        });
    }

    bindDOMContractUpgrade() {
        let self = this;
        $(document).on('click', '.js-contract-upgrade', function () {
            let contractData = $(this).data('contract-info');
            self.selectedContractForUpgrade = contractData;
            let planoAnualQtSessoes = 52;

            $('#contract_request_annual_upgrade_original_contract').val(contractData.ID);
            $('#contract_request_annual_upgrade_original_contract_sessions').val(contractData.QT_SERVICO);
            $('#contract_request_annual_upgrade_included_sessions').val(planoAnualQtSessoes - contractData.QT_SERVICO);
        });

        $(document).on('change', '#contract_request_annual_upgrade_original_contract_value', function () {
            let contractUpgradePaidValue = moeda2float($(this).val());
            let includedSessions = parseInt($('#contract_request_annual_upgrade_included_sessions').val());
            let sessionValue = (contractUpgradePaidValue / includedSessions).toFixed(2);
            $('#contract_request_annual_upgrade_session_value').val(float2moeda(sessionValue));
        });

        $(document).on('submit', '.js-contract-request-annual-upgrade-form', function (e) {
            e.preventDefault();
            let serializeData = $(this).serializeArray();
            let selfBtn = $('.js-contract-request-annual-upgrade-form').find('button[type="submit"]');
            $(".modal-contract-request-annual-upgrade-dialog").block(window._loader.loading);
            $(selfBtn).find('button[type="submit"]').prop('disabled', true);

            let formData = new FormData();
            formData.append('contract_request_annual_upgrade_original_contract', $('#contract_request_annual_upgrade_original_contract').val());
            formData.append('contract_request_annual_upgrade_original_contract_value', $('#contract_request_annual_upgrade_original_contract_value').val());
            formData.append('contract_request_annual_upgrade_included_sessions', $('#contract_request_annual_upgrade_included_sessions').val());
            formData.append('contract_request_annual_upgrade_session_value', $('#contract_request_annual_upgrade_session_value').val());
            formData.append('contract_request_annual_upgrade_file', $('#contract_request_annual_upgrade_file')[0].files[0]);

            Swal.fire({
                title: 'Confirme as informações do upgrade',
                html: `Contrato Original: ${self.selectedContractForUpgrade.ID}<br>
                        Qtd Sessões do Contrato Original: ${self.selectedContractForUpgrade.QT_SERVICO}<br>
                        Qtd Sessões que Serão Incluídas: ${$('#contract_request_annual_upgrade_included_sessions').val()}<br>
                        Valor Pago pelo Upgrade: ${$('#contract_request_annual_upgrade_original_contract_value').val()}<br>
                        Valor por Sessão: ${$('#contract_request_annual_upgrade_session_value').val()}<br>
                        `,
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6'
            }).then((result) => {
                if (result.isConfirmed) {
                    apiCall({
                        method: 'POST',
                        endpoint: 'api/v1/patient/contract/request_annual_upgrade',
                        data: formData,
                        processData: false,
                        contentType: false,
                        successCallback: function (res) {
                            $(".modal-contract-request-annual-upgrade-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                            window.toast({
                                error: res.error,
                                text: res.message
                            })
                            if (!res.error) {
                                Swal.fire({
                                    title: 'Sucesso',
                                    text: res.message,
                                    icon: 'success'
                                });
                                $('.js-contract-request-annual-upgrade-form').trigger('reset');
                                $('#modal-contract-request-annual-upgrade').modal('hide');
                            }
                        },
                        errorCallback: function (err) {
                            $(".modal-contract-request-annual-upgrade-dialog").unblock();
                            $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                        }
                    })
                } else {
                    $(".modal-contract-request-annual-upgrade-dialog").unblock();
                    $(selfBtn).find('button[type="submit"]').prop('disabled', false);
                }
            });
        });
    }

    fetchContractsList() {
        let self = this;
        $(".js-contracts-registrations-table").block(window._loader.loading);
        if (this.fetchRequest) {
            if (typeof this.fetchRequest.abort === 'function')
                this.fetchRequest.abort();
            this.fetchRequest = null;
        }
        let contractPendingSignatureFlow = $('.js-contracts-with-pending-signature-flow option:selected').val();
        let contractWithMassageTherapy = $('.js-contracts-with-massage-therapy option:selected').val();

        if (contractPendingSignatureFlow === 'S' || self.selectedBranch !== -1) {
            $('.js-contracts-export-button-container').removeClass('d-none');
        } else {
            $('.js-contracts-export-button-container').addClass('d-none');
        }

        this.fetchRequest = apiCall({
            method: 'GET',
            endpoint: 'api/v1/contracts',
            data: {
                search: self.searchQuery,
                page: self.tableHandler.getCurrentPage(),
                recordsPerPage: parseInt($('.js-contracts-per-page option:selected').val()) || 100,
                ...self.selectedBranch !== -1 ? { branchId: self.selectedBranch } : {},
                ...self.startDate !== null && self.endDate !== null ? { startDate: self.startDate, endDate: self.endDate } : {},
                ...self.serviceId !== '' && self.serviceId !== null ? { serviceId: self.serviceId } : {},
                ...self.status !== '' && self.status !== null ? { status: self.status } : {},
                ...contractPendingSignatureFlow !== '' && contractPendingSignatureFlow !== null ? { contractWithPendingSignaturesFlow: contractPendingSignatureFlow } : {},
                ...contractWithMassageTherapy !== '' && contractWithMassageTherapy !== null ? { contractWithMassageTherapy: contractWithMassageTherapy } : {},
                ...self.isPatientsPage ? { patientId: self.patientId } : {},
            },
            successCallback: function (res) {
                $(".js-contracts-registrations-table").unblock();
                if (!res.error) {
                    console.log('crud_contracts.js/contracts', res);
                    self.contractsList = res.data;
                    self.contractsTotal = res.total;
                    if (self.isPatientsPage) {
                        self.patientContracts = res.data;
                    }
                    self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.contractsList, false, self.contractsTotal);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    exportContracts(isPatientsPage) {
        let self = this;
        let contractPendingSignatureFlow = $('.js-contracts-with-pending-signature-flow option:selected').val();
        let contractWithMassageTherapy = $('.js-contracts-with-massage-therapy option:selected').val();

        apiCall({
            method: 'GET',
            endpoint: 'api/v1/contracts',
            data: {
                search: self.searchQuery,
                page: self.tableHandler.getCurrentPage(),
                recordsPerPage: parseInt($('.js-contracts-per-page option:selected').val()) || 100,
                ...self.selectedBranch !== -1 ? { branchId: self.selectedBranch } : {},
                ...self.startDate !== null && self.endDate !== null ? { startDate: self.startDate, endDate: self.endDate } : {},
                ...self.serviceId !== '' && self.serviceId !== null ? { serviceId: self.serviceId } : {},
                ...self.status !== '' && self.status !== null ? { status: self.status } : {},
                ...contractPendingSignatureFlow !== '' && contractPendingSignatureFlow !== null ? { contractWithPendingSignaturesFlow: contractPendingSignatureFlow } : {},
                ...contractWithMassageTherapy !== '' && contractWithMassageTherapy !== null ? { contractWithMassageTherapy: contractWithMassageTherapy } : {},
                ...isPatientsPage ? { patientId: self.patientId } : {},
                export: true,
            },
            successCallback: function (res) {
                console.log('response', res);

                const worksheet = XLSX.utils.json_to_sheet(res.data);

                // Create a workbook and add the worksheet to it
                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');

                // Export the workbook to an Excel file
                XLSX.writeFile(workbook, 'relatorio_contratos_' + window.getSaoPauloDateTime() + '.xlsx');

                window.toast({
                    error: false,
                    text: "Exportação realizada com sucesso."
                })
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    fetchCurrentContractViewUploads(contract_id) {
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/contract/uploads',
            data: {
                contractId: contract_id
            },
            successCallback: function (res) {
                if (res.error) {
                    window.toast({
                        error: true,
                        text: res.message
                    })
                } else {
                    let html = '';
                    for (let i in res.data) {
                        let upload = res.data[i];
                        html += `
                            <tr>
                                <td data-label="Arquivo">${upload.NOME_ARQUIVO}</td>
                                <td data-label="Antigo?">${upload.ARQUIVO.indexOf('thequiro') !== -1 ? 'Novo' : 'Antigo'}</td>
                                <td data-label="Arquivo"><a href="${upload.ARQUIVO}" target="new" class="btn btn-primary btn-sm"><i class="fas fa-download"></i> &nbsp;Baixar</a></td>
                                <td data-label="Excluir">
                                    ${userHasRole('ADMIN') ? `<a href="javascript:void(0);" data-upload-id="${upload.ID}" data-contract-id="${contract_id}" class="btn btn-danger btn-sm js-contract-delete-upload-file"><i class="fas fa-trash"></i> &nbsp;Excluir</a>` : ''}
                                </td>
                            </tr>
                        `;
                    }
                    if (res.data.length === 0) {
                        html += `<tr><td colspan="4">Nenhum upload foi realizado</tr></td>`
                    }
                    $('.js-contract-uploads-list').html(html);
                }
            },
            errorCallback: function (err) {
            }
        });
    }

    fetchContractInstallments(contract_id) {
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/contract/installments',
            data: {
                contractId: contract_id
            },
            successCallback: function (res) {
                $('.modal-marketing-transfer-lead-dialog').unblock();
                if (!res.error) {
                    let tableHtml = '';

                    for (let i in res.data) {
                        let parcela = res.data[i];

                        let formaPgtoNome = '';
                        switch (parcela.FORMA_PAGTO) {
                            case 'C':
                                formaPgtoNome = 'Cartão de Crédito';
                                break;
                            case 'D':
                                formaPgtoNome = 'Cartão de Débito';
                                break;
                            case 'I':
                                formaPgtoNome = 'Dinheiro';
                                break;
                            case 'P':
                                formaPgtoNome = 'PIX';
                                break;
                            case 'T':
                                formaPgtoNome = 'Transferência';
                                break;
                        }

                        tableHtml += `
                            <tr>
                                <td>
                                    ${parcela.CHAMADO_QUITACAO_ID == null ? `
                                        <button type="button" class="btn btn-primary js-contract-advanced-update-installment" data-installment-info='${JSON.stringify(parcela)}' data-contract-info='${JSON.stringify(self.selectedContractAdvancedUpdates)}'><i class="fas fa-edit"></i> Anexar Compr.</button>`
                                :
                                `Comprovante anexado chamado <strong>N° ${parcela.CHAMADO_QUITACAO_ID}</strong>`
                            }
                                </td>
                                <td>${parcela.ID}</td>
                                <td>${parcela.CONTRATOS_ID}</td>
                                <td>${formaPgtoNome}</td>
                                <td>${parcela.DATA_PAGAMENTO}</td>
                                <td>${parcela.NRO_PARCELAS}</td>
                                <td>${parcela.TOTAL}</td>
                                <td>${parcela.VLR_PARCELAS}</td>
                                <td>${parcela.OBS}</td>
                                <td>${parcela.USUARIO}</td>
                                <td>${parcela.TIMEUPD}</td>
                                <td>${parcela.PARCELA_PAGA}</td>
                            </tr>
                        `;
                    }

                    if (res.data.length === 0) {
                        tableHtml = `<tr><td colspan="11">Nenhuma parcela foi encontrada</td></tr>`;
                    }

                    $('.js-contract-advanced-update-installments-list').html(tableHtml);
                } else {
                    $(".modal-marketing-transfer-lead-dialog").block(window._loader.error);
                }
            },
            errorCallback: function (err) {
                $(".modal-marketing-transfer-lead-dialog").block(window._loader.error);
            }
        });
    }

    fetchContractLogs(contract_id) {
        apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/contract/logs',
            data: {
                contractId: contract_id
            },
            successCallback: function (res) {
                if (!res.error) {
                    let html = '';
                    for (let i in res.data) {
                        let log = res.data[i];
                        html += `
                            <tr>
                                <td>${log.ID}</td>
                                <td>${log.USUARIO}</td>
                                <td>${log.DATA}</td>
                                <td>${log.ACAO}</td>
                            </tr>
                        `;
                    }
                    $('.js-contract-advanced-update-logs-table-body').html(html);
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").block(window._loader.error);
            }
        });
    }

    onFillDocument(document) {
        $(".modal-edit-patient-dialog").block(window._loader.loading);

        apiCall({
            method: 'GET',
            endpoint: 'api/v1/patient/search_document',
            data: {
                document_type: $('#edit_patient_doc_type').val(),
                document: $('#edit_patient_document').cleanVal()
            },
            successCallback: function (res) {
                $(".modal-edit-patient-dialog").unblock();

                window.toast({
                    error: res.error,
                    text: res.message
                })

                if (res.error) {
                    $("#edit_patient_document").val('');
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").block(window._loader.error);
            }
        });
    }

    onFillPostalCode(postal_code) {
        $(".modal-edit-patient-dialog").block(window._loader.loading);

        apiCall({
            method: 'GET',
            endpoint: 'api/v1/cep/find',
            data: {
                postal_code: $('#edit_patient_postal_code').cleanVal()
            },
            successCallback: function (res) {
                $(".modal-edit-patient-dialog").unblock();

                if (res.cep) {
                    $('#edit_patient_address').val(res.street);
                    $('#edit_patient_address_neighborhood').val(res.neighborhood);
                    $('#edit_patient_address_city').val(res.city);
                    $('#edit_patient_address_state').val(res.state);
                } else {
                    window.toast({
                        error: true,
                        text: 'Não foi possível encontrar o CEP solicitado.'
                    })
                }
            },
            errorCallback: function (err) {
                $(".modal-edit-patient-dialog").block(window._loader.error);
            }
        });
    }

    mountTableRow(rowData) {
        let html = '';

        let planName = '';
        let serviceName = '';
        let self = this;
        for (let x in self.businessPlans) {
            if (self.businessPlans[x].ID === rowData.PLANOS_ID) {
                planName = self.businessPlans[x].DESCRICAO;
                for (let y in self.operatorAllowedServices) {
                    if (self.operatorAllowedServices[y].ID === self.businessPlans[x].SERVICOS_ID) {
                        serviceName = self.operatorAllowedServices[y].DESCRICAO;
                    }
                }
                break;
            }
        }

        let contractDataInfo = escapeSingleQuotes(JSON.stringify(rowData).replace(/"/g, '&quot;'));

        let blockBadgeAction = '';
        let blockBadgeClass = '';

        let isContractOverdue = moment().isAfter(rowData.DATA_ENCERRAMENTO_FORMATTED);

        if (rowData.BLOQUEADO == 'S') {
            if (rowData.OBS_BLOQUEIO.indexOf('INADIMPLENCIA DE PARCELA') !== -1) {
                blockBadgeAction = `data-bs-toggle="modal" data-bs-target="#modal-contract-advanced-update" data-contract-info="${contractDataInfo}"`;
                blockBadgeClass = 'js-contract-advanced-update';
            } else if (rowData.OBS_BLOQUEIO.indexOf('SEM ATENDIMENTO') !== -1 && !isContractOverdue) {
                blockBadgeAction = `data-bs-toggle="modal" data-bs-target="#modal-contract-180-day-unlock" data-contract-info="${contractDataInfo}"`;
                blockBadgeClass = 'js-contract-advanced-update';
            }
        }

        let url = getBaseDir() + 'pacientes/cadastros?' + $.param({
            patient_id: rowData.CLIENTE_ID,
            branch: rowData.FILIAL
        });

        let contractHasUploadOrIsNotBlocked = rowData.UPLOAD_CONTRATO === 'S' && (!rowData.BLOQUEADO || rowData.BLOQUEADO === null || rowData.BLOQUEADO === 'N');
        let showingTransferAndCancellationBtnBecause = contractHasUploadOrIsNotBlocked ? 'Este contrato possui fluxo assinado.' : (this.isAdminOrAssistant && !contractHasUploadOrIsNotBlocked) ? 'Estas opções só aparecem pra você administrador ou assistente (Contrato sem fluxo assinado).' : 'Este contrato não possui fluxo assinado.';

        let hasRightToTransferAndCancel = contractHasUploadOrIsNotBlocked || this.isAdmin && !contractHasUploadOrIsNotBlocked;

        html += `
        <tr style="${rowData.UPLOAD_CONTRATO == 'N' && rowData.STATUS !== 'I' && rowData.STATUS !== 'C' ? 'background:yellow;' : ''}">
            <!-- button to open sessions -->
            <td>
                ${rowData.STATUS == 'I' ? '' : `<button class="${this.isPatientsPage ? 'w-100 mb-3' : ''} btn btn-primary btn-sm js-contract-sessions-toggler js-contract-sessions-btn-${rowData.ID}" data-contract-id="${rowData.ID}" data-contract-status="${rowData.STATUS}" data-branch-id="${rowData.FILIAL_ID}"><i class="fas fa-eye"></i> &nbsp;Ver sessões</button>`}
                ${this.isPatientsPage ? ` ${rowData.STATUS !== 'I' ? `
                <div class="dropdown">
                    <button class="w-100 btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                        Ações
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        ${this.isAdminOrAssistant ? `
                        
                            <li class="dropdown-item js-contract-financial-advanced-changes" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-financial-advanced-changes" data-contract-info="${contractDataInfo}"><i class="fas fa-exchange-alt"></i> &nbsp;Alterar Forma Pagto/Ativa Contrato</li> 
                        ` : ``}
                        ${rowData.STATUS === 'A' ? `
                            ${window._sessionData.isInMainBusiness ? `
                                <li>
                                    <a class="dropdown-item js-contract-printer" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-printer" data-contract-info="${contractDataInfo}" data-print-type="quiropraxia"><i class="fas fa-print"></i> &nbsp;Imprime Quiro</a>
                                </li>
                                <li>
                                    <a class="dropdown-item js-contract-printer" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-printer" data-contract-info="${contractDataInfo}" data-print-type="massoterapia"><i class="fas fa-print"></i> &nbsp;Imprime Masso</a>
                                </li>
                                <li class="d-none">
                                    <a class="dropdown-item js-contract-printer" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-printer" data-contract-info="${contractDataInfo}" data-print-type="aromatouch"><i class="fas fa-print"></i> &nbsp;Imprime Aromatouch</a>
                                </li>
                                <li>
                                    <a class="dropdown-item ${hasRightToTransferAndCancel ? 'js-contract-transfer' : 'bg-danger text-white'} ${this.isAdmin && !contractHasUploadOrIsNotBlocked ? 'bg-warning text-white' : ''}" data-tippy-content="${showingTransferAndCancellationBtnBecause}" href="${!hasRightToTransferAndCancel ? 'javascript:void' : '#'}" ${hasRightToTransferAndCancel ? 'data-bs-toggle="modal" data-bs-target="#modal-contract-transfer"' : ''} data-contract-info="${contractDataInfo}"><i class="fas fa-exchange-alt"></i> &nbsp;Transferência</a>
                                </li>
                                <li>
                                    <a class="dropdown-item ${hasRightToTransferAndCancel ? 'js-contract-printer' : 'bg-danger text-white'} ${this.isAdmin && !contractHasUploadOrIsNotBlocked ? 'bg-warning text-white' : ''}" data-tippy-content="${showingTransferAndCancellationBtnBecause}" href="${!hasRightToTransferAndCancel ? 'javascript:void' : '#'}" ${hasRightToTransferAndCancel ? 'data-bs-toggle="modal" data-bs-target="#modal-contract-printer"' : ''} data-contract-info="${contractDataInfo}" data-print-type="cancelamento"><i class="fas fa-print"></i> &nbsp;Imprime Cancelamento</a>
                                </li>
                            ` : ''}
                        ` : rowData.STATUS === 'T' && (rowData.CONTRATO !== null && rowData.CONTRATO.toLowerCase().indexOf('recebido do') !== -1) ? `
                            <li>
                                <a class="dropdown-item js-contract-printer" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-printer" data-contract-info="${contractDataInfo}" data-print-type="transferencia"><i class="fas fa-print"></i> &nbsp;Imprime Transferência</a>
                            </li>
                        ` : rowData.STATUS === 'T' && (rowData.CONTRATO !== null && rowData.CONTRATO.toLowerCase().indexOf('enviado para') !== -1) ? `
                            <li>
                                <a class="dropdown-item" href="#"><i class="fas fa-exclamation-circle"></i> &nbsp;Inicie o fluxo por quem recebeu o contrato!</a>
                            </li>
                        ` : ''}
                        <li>
                            <a class="dropdown-item js-contract-uploads" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-upload" data-contract-info="${contractDataInfo}"><i class="fas fa-upload"></i> &nbsp;Uploads</a>
                        </li>
                        ${moment().isAfter(rowData.DATA_ENCERRAMENTO_FORMATTED) ? `
                            <li>
                                <a class="dropdown-item js-contract-printer" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-printer" data-contract-info="${contractDataInfo}" data-print-type="reativacao"><i class="fas fa-print"></i> &nbsp;Imprime Reativação</a>
                            </li>
                        ` : ''}
                        ${rowData.UPLOAD_CONTRATO === 'S' ? `
                            ${rowData.STATUS === 'A' ? `
                                ${rowData.UPGRADE_ID == null && rowData.TOTAL_PLANO > 1 ? `
                                    <li>
                                        <a class="dropdown-item js-contract-upgrade" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-request-annual-upgrade" data-contract-info="${contractDataInfo}"><i class="fas fa-exchange-alt"></i> &nbsp;Solicitar Upgrade Anual</a>
                                    </li>
                                ` : ''}
                                ${this.isAdminOrAssistant ? `
                                    <li>
                                        <a class="dropdown-item js-contract-update-commision" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-commision" data-contract-info="${contractDataInfo}"><i class="fas fa-cash-register"></i> &nbsp;Altera Comissão</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item js-contract-basic-update" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-basic-update" data-contract-info="${contractDataInfo}"><i class="fas fa-pen"></i> &nbsp;Alterações Básicas</a>
                                    </li>
                                `: ''}
                            `: ''}
                        ` : ''}
                        ${rowData.STATUS === 'A' ? `
                            <li>
                                <a class="dropdown-item js-contract-advanced-update" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-advanced-update" data-contract-info="${contractDataInfo}"><i class="fas fa-pen"></i> &nbsp;Visualização Avançada</a>
                            </li>` : ''}
                    </ul>
                </div>
                ` : ''}` : ''}
            </td>
            <td data-label="ID">${rowData.ID}</td>
            ${!this.isPatientsPage ? `<td data-label="Paciente"><a href="${url}" data-tippy-content="Ver cadastro do paciente" target="new">${rowData.CLIENTE_NOME} <i class="fas fa-external-link-alt"></i></a> <i class="far fa-copy" data-tippy-content="Copiar nome do paciente" onClick="window.copyToClipboardV2('${rowData.CLIENTE_NOME}');window.toast({error: false, text: 'Nome do paciente copiado com sucesso!'});"></i></td>` : ''}
            <td data-label="Plano">${planName}${rowData.UPGRADE_ID != null ? ` <span class="badge bg-info">Possui Upgrade</span>` : ''}</td>
            <td data-label="Serviço">${serviceName}</td>
            <td data-label="Data Adesão">${rowData.DATA_ADESAO_FORMATTED ? moment(rowData.DATA_ADESAO_FORMATTED).tz("America/Sao_Paulo").format("DD/MM/YYYY") : ""}</td>
            <td data-label="Data Encerramento">${rowData.DATA_ENCERRAMENTO_FORMATTED ? moment(rowData.DATA_ENCERRAMENTO_FORMATTED).tz("America/Sao_Paulo").format("DD/MM/YYYY") : ""}</td>
            <td data-label="Total Contrato">${rowData.STATUS == 'I' ? `` : `R$${parseFloat(rowData.TOTAL_PLANO).toFixed(2) - parseFloat(rowData.DESCONTO_VALOR).toFixed(2)}`}</td>
            <td data-label="Qt Arquivos">${parseInt(rowData.QT_ARQUIVOS) + parseInt(rowData.QT_ARQUIVOS_NOVO)}</td>
            <td data-label="Status">
                ${rowData.BLOQUEADO == 'S' ? `<br><span class="badge bg-danger ${blockBadgeClass}" ${blockBadgeAction}>Bloqueado<br>Motivo: ${rowData.OBS_BLOQUEIO}<br>Data: ${rowData.DATA_BLOQUEIO}<br/>${rowData.CHAMADO_ID_CANCELAMENTO != null ? `Chamado Contas a Pagar: ${rowData.CHAMADO_ID_CANCELAMENTO}` : ''}</span><br />` : ''}
                ${rowData.CONTRATO != null ? `<br><span class="badge bg-info">Informações<br>Motivo: ${rowData.CONTRATO}</span><br/>` : ''}
                ${(this.isAdminOrAssistant) && rowData.STATUS != 'I' && rowData.STATUS != 'T' && rowData.STATUS != 'A'
                || (this.isAdminOrAssistant) && rowData.STATUS == 'A' && isContractOverdue ? `
                    
                    <a href="javascript:void" class="js-contract-financial-reactivation" data-bs-toggle="modal" data-bs-target="#modal-contract-financial-unlock" data-contract-info="${contractDataInfo}">${isContractOverdue ? 'Contrato vencido' : getContractStatusName(rowData.STATUS, true, rowData.UPLOAD_CONTRATO)}</a>
                ` : `${isContractOverdue ? 'Contrato vencido' : getContractStatusName(rowData.STATUS, true, rowData.UPLOAD_CONTRATO)}`}
            </td>
            ${this.isPatientsPage ? '' : `<td data-label="Ações">
                ${rowData.STATUS !== 'I' ? `
                <div class="dropdown">
                    <button class="btn btn-primary btn-sm dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                        Ações
                    </button>
                    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                        ${this.isAdminOrAssistant ? `
                        
                            <li class="dropdown-item js-contract-financial-advanced-changes" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-financial-advanced-changes" data-contract-info="${contractDataInfo}"><i class="fas fa-exchange-alt"></i> &nbsp;Alterar Forma Pagto/Ativa Contrato</li> 
                        ` : ``}
                        ${rowData.STATUS === 'A' ? `
                            ${window._sessionData.isInMainBusiness ? `
                                <li>
                                    <a class="dropdown-item js-contract-printer" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-printer" data-contract-info="${contractDataInfo}" data-print-type="quiropraxia"><i class="fas fa-print"></i> &nbsp;Imprime Quiro</a>
                                </li>
                                <li>
                                    <a class="dropdown-item js-contract-printer" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-printer" data-contract-info="${contractDataInfo}" data-print-type="massoterapia"><i class="fas fa-print"></i> &nbsp;Imprime Masso</a>
                                </li>
                                <li class="d-none">
                                    <a class="dropdown-item js-contract-printer" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-printer" data-contract-info="${contractDataInfo}" data-print-type="aromatouch"><i class="fas fa-print"></i> &nbsp;Imprime Aromatouch</a>
                                </li>
                                <li>
                                    <a class="dropdown-item ${hasRightToTransferAndCancel ? 'js-contract-transfer' : 'bg-danger text-white'} ${this.isAdmin && !contractHasUploadOrIsNotBlocked ? 'bg-warning text-white' : ''}" data-tippy-content="${showingTransferAndCancellationBtnBecause}" href="${!hasRightToTransferAndCancel ? 'javascript:void' : '#'}" ${hasRightToTransferAndCancel ? 'data-bs-toggle="modal" data-bs-target="#modal-contract-transfer"' : ''} data-contract-info="${contractDataInfo}"><i class="fas fa-exchange-alt"></i> &nbsp;Transferência</a>
                                </li>
                                <li>
                                    <a class="dropdown-item ${hasRightToTransferAndCancel ? 'js-contract-printer' : 'bg-danger text-white'} ${this.isAdmin && !contractHasUploadOrIsNotBlocked ? 'bg-warning text-white' : ''}" data-tippy-content="${showingTransferAndCancellationBtnBecause}" href="${!hasRightToTransferAndCancel ? 'javascript:void' : '#'}" ${hasRightToTransferAndCancel ? 'data-bs-toggle="modal" data-bs-target="#modal-contract-printer"' : ''} data-contract-info="${contractDataInfo}" data-print-type="cancelamento"><i class="fas fa-print"></i> &nbsp;Imprime Cancelamento</a>
                                </li>
                            ` : ''}
                        ` : rowData.STATUS === 'T' && (rowData.CONTRATO !== null && rowData.CONTRATO.toLowerCase().indexOf('recebido do') !== -1) ? `
                            <li>
                                <a class="dropdown-item js-contract-printer" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-printer" data-contract-info="${contractDataInfo}" data-print-type="transferencia"><i class="fas fa-print"></i> &nbsp;Imprime Transferência</a>
                            </li>
                        ` : rowData.STATUS === 'T' && (rowData.CONTRATO !== null && rowData.CONTRATO.toLowerCase().indexOf('enviado para') !== -1) ? `
                            <li>
                                <a class="dropdown-item" href="#"><i class="fas fa-exclamation-circle"></i> &nbsp;Inicie o fluxo por quem recebeu o contrato!</a>
                            </li>
                        ` : ''}
                        <li>
                            <a class="dropdown-item js-contract-uploads" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-upload" data-contract-info="${contractDataInfo}"><i class="fas fa-upload"></i> &nbsp;Uploads</a>
                        </li>
                        ${moment().isAfter(rowData.DATA_ENCERRAMENTO_FORMATTED) ? `
                            <li>
                                <a class="dropdown-item js-contract-printer" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-printer" data-contract-info="${contractDataInfo}" data-print-type="reativacao"><i class="fas fa-print"></i> &nbsp;Imprime Reativação</a>
                            </li>
                        ` : ''}
                        ${rowData.UPLOAD_CONTRATO === 'S' ? `
                            ${rowData.STATUS === 'A' ? `
                                ${rowData.UPGRADE_ID == null && rowData.TOTAL_PLANO > 1 ? `
                                    <li>
                                        <a class="dropdown-item js-contract-upgrade" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-request-annual-upgrade" data-contract-info="${contractDataInfo}"><i class="fas fa-exchange-alt"></i> &nbsp;Solicitar Upgrade Anual</a>
                                    </li>
                                ` : ''}
                                ${this.isAdminOrAssistant ? `
                                    <li>
                                        <a class="dropdown-item js-contract-update-commision" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-commision" data-contract-info="${contractDataInfo}"><i class="fas fa-cash-register"></i> &nbsp;Altera Comissão</a>
                                    </li>
                                    <li>
                                        <a class="dropdown-item js-contract-basic-update" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-basic-update" data-contract-info="${contractDataInfo}"><i class="fas fa-pen"></i> &nbsp;Alterações Básicas</a>
                                    </li>
                                `: ''}
                            `: ''}
                        ` : ''}
                        ${rowData.STATUS === 'A' ? `
                            <li>
                                <a class="dropdown-item js-contract-advanced-update" href="#" data-bs-toggle="modal" data-bs-target="#modal-contract-advanced-update" data-contract-info="${contractDataInfo}"><i class="fas fa-pen"></i> &nbsp;Visualização Avançada</a>
                            </li>` : ''}
                    </ul>
                </div>
                ` : ''}
            </td>`}
        </tr>
        <!-- sessoes do contrato -->
        <tr class="js-contract-sessions-${rowData.ID} d-none" data-contract-id="${rowData.ID}">
            <td colspan="${!this.isPatientsPage ? 11 : 9}" class="js-contract-sessions-list-${rowData.ID}">
                <!-- spinner -->
                <div class="d-flex justify-content-center">
                    <div class="spinner-border" role="status">
                        <span class="visually-hidden">Carregando...</span>
                    </div>
                </div>
            </td>
        </tr>
        `
        return html;
    }

    fetchContractSessions(contract_id, branch_id) {
        let self = this;
        if (!this.isLoadingQuerySearch)
            $(".js-patient-data-container").block(window._loader.loading);
        getBusinessDoctorsListByBranchId(branch_id, function () {
            apiCall({
                method: 'GET',
                endpoint: 'api/v1/patient/get_current_account',
                data: {
                    contract: contract_id
                },
                successCallback: function (res) {
                    console.log('crud_patients_registrations.js/patient/get_current_account', res);

                    $(`.js-contract-sessions-btn-${contract_id}`).prop('disabled', false);

                    if (res.error) {
                        window.toast({
                            error: true,
                            text: res.message
                        })
                    } else {
                        if (res.data.length === 0) {
                            return $('.js-contract-sessions-list-' + contract_id).html(`O contrato ${contract_id} não possui sessões lançadas.`);
                        }

                        $('.js-contract-sessions-list-' + contract_id).html('');

                        let htmlInsrt = '';
                        let contratoAtual = -1;
                        for (let i = 0; i < res.data.length; ++i) {
                            let contaCorrente = res.data[i];

                            let serviceName = '';
                            for (let x = 0; x < self.operatorAllowedServices.length; x++) {
                                let service = self.operatorAllowedServices[x];
                                if (service.ID == contaCorrente.SERVICOS_ID) {
                                    serviceName = service.SERVICO;
                                    break;
                                }
                            }

                            let doctorName = contaCorrente.STAFF_NAME;
                            /*for(let x = 0; x < window.businessBranchDoctors.length; x++) {
                                let doctor = window.businessBranchDoctors[x];
                                if (doctor.DOUTOR_ID == contaCorrente.STAFF_ID) {
                                    doctorName = doctor.PRIMEIRO_NOME;
                                    break;
                                }
                            }*/

                            if (contratoAtual != contaCorrente.CONTRATO_ID) {
                                contratoAtual = contaCorrente.CONTRATO_ID;

                                $('.js-contract-sessions-list-' + contract_id).append(`
                                    <table class="mb-0 table table-bordered table-striped table-hover responsive-table">
                                        <thead>
                                            <tr>
                                                <th>ID</th>
                                                <th>Data</th>
                                                <th>Tipo</th>
                                                <th>Parcela</th>
                                                <th>Valor Unitário</th>
                                                <th>Valor Total</th>
                                                <th>% Com.</th>
                                                <th>Valor Com.</th>
                                                <th>Doutor(a)</th>
                                                <th>Status</th>
                                                <th>Atendimento</th>
                                                <th>Agendado</th>
                                                <th>Serviço</th>
                                                <th>Tipo Paciente</th>
                                                <th>Alterar Serviço</th>
                                                ${contratoAtual == '0' ? `
                                                    <th>Alterar Comissão</th>
                                                    <th>Excluir</th>
                                                ` : ''}
                                            </tr>
                                        </thead>
                                        <tbody class="js-contract-${contract_id}-sessions-table-view-${contratoAtual}">
                                            <tr>
                                                <td data-label="ID">${contaCorrente.ID}</td>
                                                <td data-label="Data">${contaCorrente.DATA_FORMATTED}</td>
                                                <td data-label="Tipo">${contaCorrente.TIPO}</td>
                                                <td data-label="Parcela">${contaCorrente.PARCELA}</td>
                                                <td data-label="Valor Unitário">R$ ${contaCorrente.VALOR_UNITARIO}</td>
                                                <td data-label="Valor Total">R$ ${contaCorrente.VALOR_TOTAL}</td>
                                                <td data-label="% Com.">${contaCorrente.COMISSAO}%</td>
                                                <td data-label="Valor com.">${contaCorrente.VALOR_COMISSAO}</td>
                                                <td data-label="Doutor(a)">${doctorName}</td>
                                                <td data-label="Status">${contaCorrente.STATUS ?? ''}</td>
                                                <td data-label="Atendimento">${contaCorrente.DATA_ATENDIMENTO_FORMATTED ?? ''}</td>
                                                <td data-label="Agendado">${contaCorrente.DATA_ATENDIMENTO_FORMATTED ?? ''}</td>
                                                <td data-label="Serviço">${serviceName}</td>
                                                <td data-label="Tipo Paciente">${contaCorrente.TIPO_PACIENTE ?? ''}</td>
                                                <td data-label="Alterar serviço"><a href="javascript:void(0);" class="js-patient-current-account-edit-service" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-pen"></i></a></td>
                                                ${contratoAtual == '0' ? `
                                                    <td data-label="Alterar comissão">${contaCorrente.TIPO != null ? `<a href="javascript:void(0);" class="js-patient-current-account-edit-doctor-comission" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-money-bill-wave-alt"></i></a>` : ''}</td>
                                                    <td data-label="Excluir">${contaCorrente.TIPO != null && contaCorrente.DATA_ATENDIMENTO_FORMATTED === null ? `<a href="javascript:void(0);" class="js-patient-current-account-delete" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-trash"></i></a>` : ''}</td>
                                                ` : ''}
                                            </tr>
                                        </tbody>
                                    </table>
                                            
                                `)
                            } else {
                                $('.js-contract-' + contract_id + '-sessions-table-view-' + contratoAtual).append(`
                                    <tr>
                                        <td data-label="ID">${contaCorrente.ID}</td>
                                        <td data-label="Data">${contaCorrente.DATA_FORMATTED}</td>
                                        <td data-label="Tipo">${contaCorrente.TIPO ?? ''}</td>
                                        <td data-label="Parcela">${contaCorrente.PARCELA ?? ''}</td>
                                        <td data-label="Valor Unitário">R$ ${contaCorrente.VALOR_UNITARIO}</td>
                                        <td data-label="Valor Total">R$ ${contaCorrente.VALOR_TOTAL}</td>
                                        <td data-label="% Com.">${contaCorrente.COMISSAO}%</td>
                                        <td data-label="Valor com.">${contaCorrente.VALOR_COMISSAO}</td>
                                        <td data-label="Doutor(a)">${doctorName}</td>
                                        <td data-label="Status">${contaCorrente.STATUS ?? ''}</td>
                                        <td data-label="Atendimento">${contaCorrente.DATA_ATENDIMENTO_FORMATTED ?? ''}</td>
                                        <td data-label="Agendado">${contaCorrente.DATA_ATENDIMENTO_FORMATTED ?? ''}</td>
                                        <td data-label="Serviço">${serviceName}</td>
                                        <td data-label="Tipo Paciennte">${contaCorrente.TIPO_PACIENTE ?? ''}</td>
                                        <td data-label="Alterar serviço"><a href="javascript:void(0);" class="js-patient-current-account-edit-service" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-pen"></i></a></td>
                                        ${contratoAtual == '0' ? `
                                            <td data-label="Alterar comissão">${contaCorrente.TIPO != null ? `<a href="javascript:void(0);" class="js-patient-current-account-edit-doctor-comission" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-money-bill-wave-alt"></i></a>` : ''}</td>
                                            <td data-label="Excluir">${contaCorrente.TIPO != null ? `<a href="javascript:void(0);" class="js-patient-current-account-delete" data-info='${JSON.stringify(contaCorrente)}'><i class="fas fa-trash"></i></a>` : ''}</td>
                                        ` : ''}
                                    </tr>
                                `);
                            }

                            htmlInsrt += `
                            `;
                        }
                        //console.log('htmlInsrt', htmlInsrt, htmlInsrt.length);
                        /*$('.js-patients-registrations-accordion-container').html(htmlInsrt == '' ? `${self.selectedPatient.CADASTRO_COMPLETO == 'N' ? 'Complete o cadastro do paciente para ver contratos' : 'Este paciente não possui nenhum contratos.'}` : `
                            <div class="accordion mb-3" id="accordionPatientsRegistrationsContracts">
                                ${htmlInsrt}
                            </div>    
                        `);*/
                    }
                },
                errorCallback: function (err) {
                    $(".js-patient-data-container").unblock();
                    $(`.js-contract-sessions-btn-${contract_id}`).prop('disabled', false);
                    //$(".js-patients-registrations-container").block(window._loader.error); // REMOVE COMMENT WHEN IN PRODUCTION
                    console.error('ERROR', 'crud_patients_registrations.js/patient/get_current_account', 'fetchPatientCurrentAccountData', err);
                }
            })
        });
    }
}